// Tempo Traveller Routes Data
// Contains vehicle options with pricing for tempo traveller bookings

export const tempoTravellerRoutes = {
  // Chandigarh Routes
  'chandigarh-amritsar': {
    from: 'Chandigarh',
    to: 'Amritsar',
    fareStart: 14000,
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    dayOptions: [],
    vehicles: [
    {
      id: 1,
      name: 'Tempo Traveller',
      seats: 12,
      luggage: 8,
      price: 14000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1d5c50116-1768362509960.png",
      imageAlt: '12 seater tempo traveller for Chandigarh to Amritsar'
    },
    {
      id: 2,
      name: 'Tempo Traveller',
      seats: 17,
      luggage: 15,
      price: 15000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_16db0878c-1768446170571.png",
      imageAlt: '17 seater tempo traveller for Chandigarh to Amritsar'
    },
    {
      id: 3,
      name: 'Tempo Traveller',
      seats: 25,
      luggage: 15,
      price: 19000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_15436b54b-1768446172655.png",
      imageAlt: '25 seater tempo traveller for Chandigarh to Amritsar'
    },
    {
      id: 4,
      name: 'Force Urbania',
      seats: 16,
      luggage: 16,
      price: 19000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_16261d7c9-1768441874753.png",
      imageAlt: '16 seater Force Urbania for Chandigarh to Amritsar'
    }]

  },
  'chandigarh-dalhousie': {
    from: 'Chandigarh',
    to: 'Dalhousie',
    fareStart: 33600,
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    dayOptions: ['1N 2D', '2N 3D', '3N 4D', '4N 5D'],
    vehicles: [
    {
      id: 1,
      name: 'Tempo Traveller',
      seats: 12,
      luggage: 8,
      price: 33600,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1a145f942-1768447884817.png",
      imageAlt: '12 seater tempo traveller for Chandigarh to Dalhousie'
    },
    {
      id: 2,
      name: 'Tempo Traveller',
      seats: 17,
      luggage: 15,
      price: 36000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1d9d3fe65-1768446170258.png",
      imageAlt: '17 seater tempo traveller for Chandigarh to Dalhousie'
    },
    {
      id: 3,
      name: 'Tempo Traveller',
      seats: 25,
      luggage: 15,
      price: 45600,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1d9d3fe65-1768446170258.png",
      imageAlt: '25 seater tempo traveller for Chandigarh to Dalhousie'
    },
    {
      id: 4,
      name: 'Force Urbania',
      seats: 16,
      luggage: 16,
      price: 45600,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_17e05246a-1768446172520.png",
      imageAlt: '16 seater Force Urbania for Chandigarh to Dalhousie'
    }]

  },
  'chandigarh-delhi-airport': {
    from: 'Chandigarh',
    to: 'Delhi Airport',
    fareStart: 14000,
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    dayOptions: [],
    vehicles: [
    {
      id: 1,
      name: 'Tempo Traveller',
      seats: 12,
      luggage: 8,
      price: 14000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1d5c50116-1768362509960.png",
      imageAlt: '12 seater tempo traveller for Chandigarh to Delhi Airport'
    },
    {
      id: 2,
      name: 'Tempo Traveller',
      seats: 17,
      luggage: 15,
      price: 15000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_16db0878c-1768446170571.png",
      imageAlt: '17 seater tempo traveller for Chandigarh to Delhi Airport'
    },
    {
      id: 3,
      name: 'Tempo Traveller',
      seats: 25,
      luggage: 15,
      price: 19000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1e683c4c0-1768529841444.png",
      imageAlt: '25 seater tempo traveller for Chandigarh to Delhi Airport'
    },
    {
      id: 4,
      name: 'Force Urbania',
      seats: 16,
      luggage: 16,
      price: 19000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_17382ec97-1768621133805.png",
      imageAlt: '16 seater Force Urbania for Chandigarh to Delhi Airport'
    }]

  },
  'chandigarh-delhi': {
    from: 'Chandigarh',
    to: 'Delhi',
    fareStart: 14000,
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    dayOptions: [],
    vehicles: [
    {
      id: 1,
      name: 'Tempo Traveller',
      seats: 12,
      luggage: 8,
      price: 14000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_11d668f2d-1768440186997.png",
      imageAlt: '12 seater tempo traveller for Chandigarh to Delhi'
    },
    {
      id: 2,
      name: 'Tempo Traveller',
      seats: 17,
      luggage: 15,
      price: 15000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_114e4d671-1768440186864.png",
      imageAlt: '17 seater tempo traveller for Chandigarh to Delhi'
    },
    {
      id: 3,
      name: 'Tempo Traveller',
      seats: 25,
      luggage: 15,
      price: 19000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1644f1da7-1768446172234.png",
      imageAlt: '25 seater tempo traveller for Chandigarh to Delhi'
    },
    {
      id: 4,
      name: 'Force Urbania',
      seats: 16,
      luggage: 16,
      price: 19000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1d461a4d4-1768082329835.png",
      imageAlt: '16 seater Force Urbania for Chandigarh to Delhi'
    }]

  },
  'chandigarh-dharamshala': {
    from: 'Chandigarh',
    to: 'Dharamshala',
    fareStart: 21000,
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    dayOptions: ['2N 3D', '3N 4D', '4N 5D', '5N 6D'],
    vehicles: [
    {
      id: 1,
      name: 'Tempo Traveller',
      seats: 12,
      luggage: 8,
      price: 21000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_183d41f7a-1768446172603.png",
      imageAlt: '12 seater tempo traveller for Chandigarh to Dharamshala'
    },
    {
      id: 2,
      name: 'Tempo Traveller',
      seats: 17,
      luggage: 15,
      price: 22500,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_199216fec-1768447110584.png",
      imageAlt: '17 seater tempo traveller for Chandigarh to Dharamshala'
    },
    {
      id: 3,
      name: 'Tempo Traveller',
      seats: 25,
      luggage: 15,
      price: 28500,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1a145f942-1768447884817.png",
      imageAlt: '25 seater tempo traveller for Chandigarh to Dharamshala'
    },
    {
      id: 4,
      name: 'Force Urbania',
      seats: 16,
      luggage: 16,
      price: 28500,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1e683c4c0-1768529841444.png",
      imageAlt: '16 seater Force Urbania for Chandigarh to Dharamshala'
    }]

  },
  'chandigarh-kasol': {
    from: 'Chandigarh',
    to: 'Kasol',
    fareStart: 22400,
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    dayOptions: ['2N 3D', '3N 4D', '4N 5D'],
    vehicles: [
    {
      id: 1,
      name: 'Tempo Traveller',
      seats: 12,
      luggage: 8,
      price: 22400,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_15436b54b-1768446172655.png",
      imageAlt: '12 seater tempo traveller for Chandigarh to Kasol'
    },
    {
      id: 2,
      name: 'Tempo Traveller',
      seats: 17,
      luggage: 15,
      price: 24000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1a145f942-1768447884817.png",
      imageAlt: '17 seater tempo traveller for Chandigarh to Kasol'
    },
    {
      id: 3,
      name: 'Tempo Traveller',
      seats: 25,
      luggage: 15,
      price: 30400,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1a145f942-1768447884817.png",
      imageAlt: '25 seater tempo traveller for Chandigarh to Kasol'
    },
    {
      id: 4,
      name: 'Force Urbania',
      seats: 16,
      luggage: 16,
      price: 30400,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1a145f942-1768447884817.png",
      imageAlt: '16 seater Force Urbania for Chandigarh to Kasol'
    }]

  },
  'chandigarh-khatu-shyam': {
    from: 'Chandigarh',
    to: 'Khatu Shyam',
    fareStart: 30800,
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    dayOptions: ['1N 2D', '2N 3D', '3N 4D'],
    vehicles: [
    {
      id: 1,
      name: 'Tempo Traveller',
      seats: 12,
      luggage: 8,
      price: 30800,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_199216fec-1768447110584.png",
      imageAlt: '12 seater tempo traveller for Chandigarh to Khatu Shyam'
    },
    {
      id: 2,
      name: 'Tempo Traveller',
      seats: 17,
      luggage: 15,
      price: 33000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1e683c4c0-1768529841444.png",
      imageAlt: '17 seater tempo traveller for Chandigarh to Khatu Shyam'
    },
    {
      id: 3,
      name: 'Tempo Traveller',
      seats: 25,
      luggage: 15,
      price: 41800,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_15436b54b-1768446172655.png",
      imageAlt: '25 seater tempo traveller for Chandigarh to Khatu Shyam'
    },
    {
      id: 4,
      name: 'Force Urbania',
      seats: 16,
      luggage: 16,
      price: 41800,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1be0024a8-1767645973805.png",
      imageAlt: '16 seater Force Urbania for Chandigarh to Khatu Shyam'
    }]

  },
  'chandigarh-mathura': {
    from: 'Chandigarh',
    to: 'Mathura',
    fareStart: 22400,
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    dayOptions: ['1N 2D', '2N 3D'],
    vehicles: [
    {
      id: 1,
      name: 'Tempo Traveller',
      seats: 12,
      luggage: 8,
      price: 22400,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1f689fc9e-1768446173116.png",
      imageAlt: '12 seater tempo traveller for Chandigarh to Mathura'
    },
    {
      id: 2,
      name: 'Tempo Traveller',
      seats: 17,
      luggage: 15,
      price: 24000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1d461a4d4-1768082329835.png",
      imageAlt: '17 seater tempo traveller for Chandigarh to Mathura'
    },
    {
      id: 3,
      name: 'Tempo Traveller',
      seats: 25,
      luggage: 15,
      price: 30400,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1f689fc9e-1768446173116.png",
      imageAlt: '25 seater tempo traveller for Chandigarh to Mathura'
    },
    {
      id: 4,
      name: 'Force Urbania',
      seats: 16,
      luggage: 16,
      price: 30400,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_168e77c63-1768440186935.png",
      imageAlt: '16 seater Force Urbania for Chandigarh to Mathura'
    }]

  },
  'chandigarh-mussoorie': {
    from: 'Chandigarh',
    to: 'Mussoorie',
    fareStart: 22400,
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    dayOptions: ['1N 2D', '2N 3D', '3N 4D'],
    vehicles: [
    {
      id: 1,
      name: 'Tempo Traveller',
      seats: 12,
      luggage: 8,
      price: 22400,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_199216fec-1768447110584.png",
      imageAlt: '12 seater tempo traveller for Chandigarh to Mussoorie'
    },
    {
      id: 2,
      name: 'Tempo Traveller',
      seats: 17,
      luggage: 15,
      price: 24000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_199216fec-1768447110584.png",
      imageAlt: '17 seater tempo traveller for Chandigarh to Mussoorie'
    },
    {
      id: 3,
      name: 'Tempo Traveller',
      seats: 25,
      luggage: 15,
      price: 30400,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1e683c4c0-1768529841444.png",
      imageAlt: '25 seater tempo traveller for Chandigarh to Mussoorie'
    },
    {
      id: 4,
      name: 'Force Urbania',
      seats: 16,
      luggage: 16,
      price: 30400,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1661ae2ce-1765191981302.png",
      imageAlt: '16 seater Force Urbania for Chandigarh to Mussoorie'
    }]

  },
  'chandigarh-shimla': {
    from: 'Chandigarh',
    to: 'Shimla',
    fareStart: 16800,
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    dayOptions: ['1N 2D', '2N 3D', '3N 4D'],
    vehicles: [
    {
      id: 1,
      name: 'Tempo Traveller',
      seats: 12,
      luggage: 8,
      price: 16800,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_16db0878c-1768446170571.png",
      imageAlt: '12 seater tempo traveller for Chandigarh to Shimla'
    },
    {
      id: 2,
      name: 'Tempo Traveller',
      seats: 17,
      luggage: 15,
      price: 18000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1d9d3fe65-1768446170258.png",
      imageAlt: '17 seater tempo traveller for Chandigarh to Shimla'
    },
    {
      id: 3,
      name: 'Tempo Traveller',
      seats: 25,
      luggage: 15,
      price: 22800,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_16db0878c-1768446170571.png",
      imageAlt: '25 seater tempo traveller for Chandigarh to Shimla'
    },
    {
      id: 4,
      name: 'Force Urbania',
      seats: 16,
      luggage: 16,
      price: 22800,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1d461a4d4-1768082329835.png",
      imageAlt: '16 seater Force Urbania for Chandigarh to Shimla'
    }]

  },
  'chandigarh-takhat-sachkhand-sri-hazur-sahib': {
    from: 'Chandigarh',
    to: 'Takhat Sachkhand Sri Hazur Sahib',
    fareStart: 123200,
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    dayOptions: ['5N 6D', '6N 7D', '7N 8D', '8N 9D'],
    vehicles: [
    {
      id: 1,
      name: 'Tempo Traveller',
      seats: 12,
      luggage: 8,
      price: 123200,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1f689fc9e-1768446173116.png",
      imageAlt: '12 seater tempo traveller for Chandigarh to Takhat Sachkhand Sri Hazur Sahib'
    },
    {
      id: 2,
      name: 'Tempo Traveller',
      seats: 17,
      luggage: 15,
      price: 132000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1d5c50116-1768362509960.png",
      imageAlt: '17 seater tempo traveller for Chandigarh to Takhat Sachkhand Sri Hazur Sahib'
    },
    {
      id: 3,
      name: 'Tempo Traveller',
      seats: 25,
      luggage: 15,
      price: 167200,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1f689fc9e-1768446173116.png",
      imageAlt: '25 seater tempo traveller for Chandigarh to Takhat Sachkhand Sri Hazur Sahib'
    },
    {
      id: 4,
      name: 'Force Urbania',
      seats: 16,
      luggage: 16,
      price: 167200,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_18ecbb159-1768520248568.png",
      imageAlt: '16 seater Force Urbania for Chandigarh to Takhat Sachkhand Sri Hazur Sahib'
    }]

  },

  // Delhi Routes
  'delhi-amritsar': {
    from: 'Delhi',
    to: 'Amritsar',
    fareStart: 28000,
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    dayOptions: ['1N 2D', '2N 3D'],
    vehicles: [
    {
      id: 1,
      name: 'Tempo Traveller',
      seats: 12,
      luggage: 8,
      price: 28000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1c9851b8f-1768447109831.png",
      imageAlt: '12 seater tempo traveller for Delhi to Amritsar'
    },
    {
      id: 2,
      name: 'Tempo Traveller',
      seats: 17,
      luggage: 15,
      price: 30000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1c9851b8f-1768447109831.png",
      imageAlt: '17 seater tempo traveller for Delhi to Amritsar'
    },
    {
      id: 3,
      name: 'Tempo Traveller',
      seats: 25,
      luggage: 15,
      price: 38000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1c9851b8f-1768447109831.png",
      imageAlt: '25 seater tempo traveller for Delhi to Amritsar'
    },
    {
      id: 4,
      name: 'Force Urbania',
      seats: 16,
      luggage: 16,
      price: 38000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1d9d3fe65-1768446170258.png",
      imageAlt: '16 seater Force Urbania for Delhi to Amritsar'
    }]

  },
  'delhi-manali': {
    from: 'Delhi',
    to: 'Manali',
    fareStart: 33600,
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    dayOptions: ['2N 3D', '3N 4D', '4N 5D', '5N 6D'],
    vehicles: [
    {
      id: 1,
      name: 'Tempo Traveller',
      seats: 12,
      luggage: 8,
      price: 33600,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_19f4caefc-1768446172653.png",
      imageAlt: '12 seater tempo traveller for Delhi to Manali'
    },
    {
      id: 2,
      name: 'Tempo Traveller',
      seats: 17,
      luggage: 15,
      price: 36000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1a145f942-1768447884817.png",
      imageAlt: '17 seater tempo traveller for Delhi to Manali'
    },
    {
      id: 3,
      name: 'Tempo Traveller',
      seats: 25,
      luggage: 15,
      price: 45600,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1644f1da7-1768446172234.png",
      imageAlt: '25 seater tempo traveller for Delhi to Manali'
    },
    {
      id: 4,
      name: 'Force Urbania',
      seats: 16,
      luggage: 16,
      price: 45600,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1e683c4c0-1768529841444.png",
      imageAlt: '16 seater Force Urbania for Delhi to Manali'
    }]

  },
  'delhi-shimla': {
    from: 'Delhi',
    to: 'Shimla',
    fareStart: 25200,
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    dayOptions: ['1N 2D', '2N 3D', '3N 4D'],
    vehicles: [
    {
      id: 1,
      name: 'Tempo Traveller',
      seats: 12,
      luggage: 8,
      price: 25200,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1d461a4d4-1768082329835.png",
      imageAlt: '12 seater tempo traveller for Delhi to Shimla'
    },
    {
      id: 2,
      name: 'Tempo Traveller',
      seats: 17,
      luggage: 15,
      price: 27000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_183d41f7a-1768446172603.png",
      imageAlt: '17 seater tempo traveller for Delhi to Shimla'
    },
    {
      id: 3,
      name: 'Tempo Traveller',
      seats: 25,
      luggage: 15,
      price: 34200,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1e683c4c0-1768529841444.png",
      imageAlt: '25 seater tempo traveller for Delhi to Shimla'
    },
    {
      id: 4,
      name: 'Force Urbania',
      seats: 16,
      luggage: 16,
      price: 34200,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1e683c4c0-1768529841444.png",
      imageAlt: '16 seater Force Urbania for Delhi to Shimla'
    }]

  },
  'delhi-dharamshala': {
    from: 'Delhi',
    to: 'Dharamshala',
    fareStart: 33600,
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    dayOptions: ['2N 3D', '3N 4D', '4N 5D', '5N 6D'],
    vehicles: [
    {
      id: 1,
      name: 'Tempo Traveller',
      seats: 12,
      luggage: 8,
      price: 33600,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_16f41fd6f-1768440186961.png",
      imageAlt: '12 seater tempo traveller for Delhi to Dharamshala'
    },
    {
      id: 2,
      name: 'Tempo Traveller',
      seats: 17,
      luggage: 15,
      price: 36000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_199216fec-1768447110584.png",
      imageAlt: '17 seater tempo traveller for Delhi to Dharamshala'
    },
    {
      id: 3,
      name: 'Tempo Traveller',
      seats: 25,
      luggage: 15,
      price: 45600,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_19f4caefc-1768446172653.png",
      imageAlt: '25 seater tempo traveller for Delhi to Dharamshala'
    },
    {
      id: 4,
      name: 'Force Urbania',
      seats: 16,
      luggage: 16,
      price: 45600,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1d5c50116-1768362509960.png",
      imageAlt: '16 seater Force Urbania for Delhi to Dharamshala'
    }]

  },
  'delhi-dalhousie': {
    from: 'Delhi',
    to: 'Dalhousie',
    fareStart: 39200,
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    dayOptions: ['2N 3D', '3N 4D', '4N 5D'],
    vehicles: [
    {
      id: 1,
      name: 'Tempo Traveller',
      seats: 12,
      luggage: 8,
      price: 39200,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1d5c50116-1768362509960.png",
      imageAlt: '12 seater tempo traveller for Delhi to Dalhousie'
    },
    {
      id: 2,
      name: 'Tempo Traveller',
      seats: 17,
      luggage: 15,
      price: 42000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_13dbe834c-1768440184022.png",
      imageAlt: '17 seater tempo traveller for Delhi to Dalhousie'
    },
    {
      id: 3,
      name: 'Tempo Traveller',
      seats: 25,
      luggage: 15,
      price: 53200,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_13dbe834c-1768440184022.png",
      imageAlt: '25 seater tempo traveller for Delhi to Dalhousie'
    },
    {
      id: 4,
      name: 'Force Urbania',
      seats: 16,
      luggage: 16,
      price: 53200,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1d9d3fe65-1768446170258.png",
      imageAlt: '16 seater Force Urbania for Delhi to Dalhousie'
    }]

  },
  'delhi-mussoorie': {
    from: 'Delhi',
    to: 'Mussoorie',
    fareStart: 22400,
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    dayOptions: ['1N 2D', '2N 3D', '3N 4D'],
    vehicles: [
    {
      id: 1,
      name: 'Tempo Traveller',
      seats: 12,
      luggage: 8,
      price: 22400,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_16f41fd6f-1768440186961.png",
      imageAlt: '12 seater tempo traveller for Delhi to Mussoorie'
    },
    {
      id: 2,
      name: 'Tempo Traveller',
      seats: 17,
      luggage: 15,
      price: 24000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_17e05246a-1768446172520.png",
      imageAlt: '17 seater tempo traveller for Delhi to Mussoorie'
    },
    {
      id: 3,
      name: 'Tempo Traveller',
      seats: 25,
      luggage: 15,
      price: 30400,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_11d668f2d-1768440186997.png",
      imageAlt: '25 seater tempo traveller for Delhi to Mussoorie'
    },
    {
      id: 4,
      name: 'Force Urbania',
      seats: 16,
      luggage: 16,
      price: 30400,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1e683c4c0-1768529841444.png",
      imageAlt: '16 seater Force Urbania for Delhi to Mussoorie'
    }]

  },
  'delhi-himachal-pradesh': {
    from: 'Delhi',
    to: 'Himachal Pradesh',
    fareStart: 33600,
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    dayOptions: ['2N 3D', '3N 4D', '4N 5D', '5N 6D', '7N 8D'],
    vehicles: [
    {
      id: 1,
      name: 'Tempo Traveller',
      seats: 12,
      luggage: 8,
      price: 33600,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_15436b54b-1768446172655.png",
      imageAlt: '12 seater tempo traveller for Delhi to Himachal Pradesh'
    },
    {
      id: 2,
      name: 'Tempo Traveller',
      seats: 17,
      luggage: 15,
      price: 36000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_183d41f7a-1768446172603.png",
      imageAlt: '17 seater tempo traveller for Delhi to Himachal Pradesh'
    },
    {
      id: 3,
      name: 'Tempo Traveller',
      seats: 25,
      luggage: 15,
      price: 45600,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_183d41f7a-1768446172603.png",
      imageAlt: '25 seater tempo traveller for Delhi to Himachal Pradesh'
    },
    {
      id: 4,
      name: 'Force Urbania',
      seats: 16,
      luggage: 16,
      price: 45600,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1e683c4c0-1768529841444.png",
      imageAlt: '16 seater Force Urbania for Delhi to Himachal Pradesh'
    }]

  },
  'delhi-khatu-shyam': {
    from: 'Delhi',
    to: 'Khatu Shyam',
    fareStart: 22400,
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    dayOptions: ['1N 2D', '2N 3D'],
    vehicles: [
    {
      id: 1,
      name: 'Tempo Traveller',
      seats: 12,
      luggage: 8,
      price: 22400,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1d9d3fe65-1768446170258.png",
      imageAlt: '12 seater tempo traveller for Delhi to Khatu Shyam'
    },
    {
      id: 2,
      name: 'Tempo Traveller',
      seats: 17,
      luggage: 15,
      price: 24000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1d5c50116-1768362509960.png",
      imageAlt: '17 seater tempo traveller for Delhi to Khatu Shyam'
    },
    {
      id: 3,
      name: 'Tempo Traveller',
      seats: 25,
      luggage: 15,
      price: 30400,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1e6a08f76-1768621133289.png",
      imageAlt: '25 seater tempo traveller for Delhi to Khatu Shyam'
    },
    {
      id: 4,
      name: 'Force Urbania',
      seats: 16,
      luggage: 16,
      price: 30400,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_11d668f2d-1768440186997.png",
      imageAlt: '16 seater Force Urbania for Delhi to Khatu Shyam'
    }]

  },
  'delhi-salasar-balaji': {
    from: 'Delhi',
    to: 'Salasar Balaji',
    fareStart: 19600,
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    dayOptions: ['1N 2D', '2N 3D'],
    vehicles: [
    {
      id: 1,
      name: 'Tempo Traveller',
      seats: 12,
      luggage: 8,
      price: 19600,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1a145f942-1768447884817.png",
      imageAlt: '12 seater tempo traveller for Delhi to Salasar Balaji'
    },
    {
      id: 2,
      name: 'Tempo Traveller',
      seats: 17,
      luggage: 15,
      price: 21000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_170a50dad-1768446172885.png",
      imageAlt: '17 seater tempo traveller for Delhi to Salasar Balaji'
    },
    {
      id: 3,
      name: 'Tempo Traveller',
      seats: 25,
      luggage: 15,
      price: 26600,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_170a50dad-1768446172885.png",
      imageAlt: '25 seater tempo traveller for Delhi to Salasar Balaji'
    },
    {
      id: 4,
      name: 'Force Urbania',
      seats: 16,
      luggage: 16,
      price: 26600,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_16f41fd6f-1768440186961.png",
      imageAlt: '16 seater Force Urbania for Delhi to Salasar Balaji'
    }]

  },
  'delhi-kasol': {
    from: 'Delhi',
    to: 'Kasol',
    fareStart: 33600,
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    dayOptions: ['2N 3D', '3N 4D', '4N 5D'],
    vehicles: [
    {
      id: 1,
      name: 'Tempo Traveller',
      seats: 12,
      luggage: 8,
      price: 33600,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_16db0878c-1768446170571.png",
      imageAlt: '12 seater tempo traveller for Delhi to Kasol'
    },
    {
      id: 2,
      name: 'Tempo Traveller',
      seats: 17,
      luggage: 15,
      price: 36000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_16db0878c-1768446170571.png",
      imageAlt: '17 seater tempo traveller for Delhi to Kasol'
    },
    {
      id: 3,
      name: 'Tempo Traveller',
      seats: 25,
      luggage: 15,
      price: 45600,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1a145f942-1768447884817.png",
      imageAlt: '25 seater tempo traveller for Delhi to Kasol'
    },
    {
      id: 4,
      name: 'Force Urbania',
      seats: 16,
      luggage: 16,
      price: 45600,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1e683c4c0-1768529841444.png",
      imageAlt: '16 seater Force Urbania for Delhi to Kasol'
    }]

  },
  'delhi-mathura': {
    from: 'Delhi',
    to: 'Mathura',
    fareStart: 16800,
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    dayOptions: ['1N 2D'],
    vehicles: [
    {
      id: 1,
      name: 'Tempo Traveller',
      seats: 12,
      luggage: 8,
      price: 16800,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1d9d3fe65-1768446170258.png",
      imageAlt: '12 seater tempo traveller for Delhi to Mathura'
    },
    {
      id: 2,
      name: 'Tempo Traveller',
      seats: 17,
      luggage: 15,
      price: 18000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_16db0878c-1768446170571.png",
      imageAlt: '17 seater tempo traveller for Delhi to Mathura'
    },
    {
      id: 3,
      name: 'Tempo Traveller',
      seats: 25,
      luggage: 15,
      price: 22800,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1f689fc9e-1768446173116.png",
      imageAlt: '25 seater tempo traveller for Delhi to Mathura'
    },
    {
      id: 4,
      name: 'Force Urbania',
      seats: 16,
      luggage: 16,
      price: 22800,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_183d41f7a-1768446172603.png",
      imageAlt: '16 seater Force Urbania for Delhi to Mathura'
    }]

  },
  'delhi-vrindavan': {
    from: 'Delhi',
    to: 'Vrindavan',
    fareStart: 16800,
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    dayOptions: ['1N 2D'],
    vehicles: [
    {
      id: 1,
      name: 'Tempo Traveller',
      seats: 12,
      luggage: 8,
      price: 16800,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1d9d3fe65-1768446170258.png",
      imageAlt: '12 seater tempo traveller for Delhi to Vrindavan'
    },
    {
      id: 2,
      name: 'Tempo Traveller',
      seats: 17,
      luggage: 15,
      price: 18000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_188d54dc6-1768446169568.png",
      imageAlt: '17 seater tempo traveller for Delhi to Vrindavan'
    },
    {
      id: 3,
      name: 'Tempo Traveller',
      seats: 25,
      luggage: 15,
      price: 22800,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_16ec77c72-1768446172526.png",
      imageAlt: '25 seater tempo traveller for Delhi to Vrindavan'
    },
    {
      id: 4,
      name: 'Force Urbania',
      seats: 16,
      luggage: 16,
      price: 22800,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_183d41f7a-1768446172603.png",
      imageAlt: '16 seater Force Urbania for Delhi to Vrindavan'
    }]

  },

  // Amritsar Routes
  'amritsar-chandigarh': {
    from: 'Amritsar',
    to: 'Chandigarh',
    fareStart: 14000,
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    dayOptions: [],
    vehicles: [
    {
      id: 1,
      name: 'Tempo Traveller',
      seats: 12,
      luggage: 8,
      price: 14000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_15436b54b-1768446172655.png",
      imageAlt: '12 seater tempo traveller for Amritsar to Chandigarh'
    },
    {
      id: 2,
      name: 'Tempo Traveller',
      seats: 17,
      luggage: 15,
      price: 15000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_13dbe834c-1768440184022.png",
      imageAlt: '17 seater tempo traveller for Amritsar to Chandigarh'
    },
    {
      id: 3,
      name: 'Tempo Traveller',
      seats: 25,
      luggage: 15,
      price: 19000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_168e77c63-1768440186935.png",
      imageAlt: '25 seater tempo traveller for Amritsar to Chandigarh'
    },
    {
      id: 4,
      name: 'Force Urbania',
      seats: 16,
      luggage: 16,
      price: 19000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1a08822b9-1768617097186.png",
      imageAlt: '16 seater Force Urbania for Amritsar to Chandigarh'
    }]

  },
  'amritsar-agra': {
    from: 'Amritsar',
    to: 'Agra',
    fareStart: 47600,
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    dayOptions: ['3N 4D', '4N 5D', '5N 6D', '6N 7D'],
    vehicles: [
    {
      id: 1,
      name: 'Tempo Traveller',
      seats: 12,
      luggage: 8,
      price: 47600,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1f1942669-1768440186993.png",
      imageAlt: '12 seater tempo traveller for Amritsar to Agra'
    },
    {
      id: 2,
      name: 'Tempo Traveller',
      seats: 17,
      luggage: 15,
      price: 51000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1f1942669-1768440186993.png",
      imageAlt: '17 seater tempo traveller for Amritsar to Agra'
    },
    {
      id: 3,
      name: 'Tempo Traveller',
      seats: 25,
      luggage: 15,
      price: 64600,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_16261d7c9-1768441874753.png",
      imageAlt: '25 seater tempo traveller for Amritsar to Agra'
    },
    {
      id: 4,
      name: 'Force Urbania',
      seats: 16,
      luggage: 16,
      price: 64600,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1fbb47e0d-1768617098310.png",
      imageAlt: '16 seater Force Urbania for Amritsar to Agra'
    }]
  },
  'amritsar-amarnath': {
    from: 'Amritsar',
    to: 'Amarnath',
    fareStart: 42000,
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    dayOptions: ['4N 5D', '5N 6D', '6N 7D', '7N 8D', '8N 9D'],
    vehicles: [
    {
      id: 1,
      name: 'Tempo Traveller',
      seats: 12,
      luggage: 8,
      price: 42000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1759a0f6e-1768440186956.png",
      imageAlt: '12 seater tempo traveller for Amritsar to Amarnath'
    },
    {
      id: 2,
      name: 'Tempo Traveller',
      seats: 17,
      luggage: 15,
      price: 45000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1759a0f6e-1768440186956.png",
      imageAlt: '17 seater tempo traveller for Amritsar to Amarnath'
    },
    {
      id: 3,
      name: 'Tempo Traveller',
      seats: 25,
      luggage: 15,
      price: 57000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1759a0f6e-1768440186956.png",
      imageAlt: '25 seater tempo traveller for Amritsar to Amarnath'
    },
    {
      id: 4,
      name: 'Force Urbania',
      seats: 16,
      luggage: 16,
      price: 57000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_15436b54b-1768446172655.png",
      imageAlt: '16 seater Force Urbania for Amritsar to Amarnath'
    }]
  },
  'amritsar-ayodhya': {
    from: 'Amritsar',
    to: 'Ayodhya',
    fareStart: 84000,
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    dayOptions: ['4N 5D', '5N 6D', '6N 7D', '7N 8D', '8N 9D'],
    vehicles: [
    {
      id: 1,
      name: 'Tempo Traveller',
      seats: 12,
      luggage: 8,
      price: 84000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_15436b54b-1768446172655.png",
      imageAlt: '12 seater tempo traveller for Amritsar to Ayodhya'
    },
    {
      id: 2,
      name: 'Tempo Traveller',
      seats: 17,
      luggage: 15,
      price: 90000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1390400ab-1768447858097.png",
      imageAlt: '17 seater tempo traveller for Amritsar to Ayodhya'
    },
    {
      id: 3,
      name: 'Tempo Traveller',
      seats: 25,
      luggage: 15,
      price: 114000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1f7797663-1768441873616.png",
      imageAlt: '25 seater tempo traveller for Amritsar to Ayodhya'
    },
    {
      id: 4,
      name: 'Force Urbania',
      seats: 16,
      luggage: 16,
      price: 114000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_183d41f7a-1768446172603.png",
      imageAlt: '16 seater Force Urbania for Amritsar to Ayodhya'
    }]
  },
  'amritsar-badrinath-kedarnath': {
    from: 'Amritsar',
    to: 'Badrinath Kedarnath',
    fareStart: 86800,
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    dayOptions: ['5N 6D', '6N 7D', '7N 8D', '8N 9D', '9N 10D'],
    vehicles: [
    {
      id: 1,
      name: 'Tempo Traveller',
      seats: 12,
      luggage: 8,
      price: 86800,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_168e77c63-1768440186935.png",
      imageAlt: '12 seater tempo traveller for Amritsar to Badrinath Kedarnath'
    },
    {
      id: 2,
      name: 'Tempo Traveller',
      seats: 17,
      luggage: 15,
      price: 93000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_168e77c63-1768440186935.png",
      imageAlt: '17 seater tempo traveller for Amritsar to Badrinath Kedarnath'
    },
    {
      id: 3,
      name: 'Tempo Traveller',
      seats: 25,
      luggage: 15,
      price: 117800,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1cc5e2f9b-1768447111427.png",
      imageAlt: '25 seater tempo traveller for Amritsar to Badrinath Kedarnath'
    },
    {
      id: 4,
      name: 'Force Urbania',
      seats: 16,
      luggage: 16,
      price: 117800,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1e683c4c0-1768529841444.png",
      imageAlt: '16 seater Force Urbania for Amritsar to Badrinath Kedarnath'
    }]
  },
  'amritsar-char-dham': {
    from: 'Amritsar',
    to: 'Char Dham',
    fareStart: 86800,
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    dayOptions: ['5N 6D', '6N 7D', '7N 8D', '8N 9D', '9N 10D'],
    vehicles: [
    {
      id: 1,
      name: 'Tempo Traveller',
      seats: 12,
      luggage: 8,
      price: 86800,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_19f232574-1768446172689.png",
      imageAlt: '12 seater tempo traveller for Amritsar to Char Dham'
    },
    {
      id: 2,
      name: 'Tempo Traveller',
      seats: 17,
      luggage: 15,
      price: 93000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_15436b54b-1768446172655.png",
      imageAlt: '17 seater tempo traveller for Amritsar to Char Dham'
    },
    {
      id: 3,
      name: 'Tempo Traveller',
      seats: 25,
      luggage: 15,
      price: 117800,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_188d54dc6-1768446169568.png",
      imageAlt: '25 seater tempo traveller for Amritsar to Char Dham'
    },
    {
      id: 4,
      name: 'Force Urbania',
      seats: 16,
      luggage: 16,
      price: 117800,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_15436b54b-1768446172655.png",
      imageAlt: '16 seater Force Urbania for Amritsar to Char Dham'
    }]
  },
  'amritsar-dalhousie': {
    from: 'Amritsar',
    to: 'Dalhousie',
    fareStart: 25200,
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    dayOptions: ['1N 2D', '2N 3D', '3N 4D', '4N 5D'],
    vehicles: [
    {
      id: 1,
      name: 'Tempo Traveller',
      seats: 12,
      luggage: 8,
      price: 25200,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_174173c65-1768446172648.png",
      imageAlt: '12 seater tempo traveller for Amritsar to Dalhousie'
    },
    {
      id: 2,
      name: 'Tempo Traveller',
      seats: 17,
      luggage: 15,
      price: 27000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_15436b54b-1768446172655.png",
      imageAlt: '17 seater tempo traveller for Amritsar to Dalhousie'
    },
    {
      id: 3,
      name: 'Tempo Traveller',
      seats: 25,
      luggage: 15,
      price: 34200,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_188d54dc6-1768446169568.png",
      imageAlt: '25 seater tempo traveller for Amritsar to Dalhousie'
    },
    {
      id: 4,
      name: 'Force Urbania',
      seats: 16,
      luggage: 16,
      price: 34200,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1edd42d27-1768617097934.png",
      imageAlt: '16 seater Force Urbania for Amritsar to Dalhousie'
    }]
  },
  'amritsar-dharamshala': {
    from: 'Amritsar',
    to: 'Dharamshala',
    fareStart: 30800,
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    dayOptions: ['2N 3D', '3N 4D', '4N 5D', '5N 6D', '6N 7D', '7N 8D'],
    vehicles: [
    {
      id: 1,
      name: 'Tempo Traveller',
      seats: 12,
      luggage: 8,
      price: 30800,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_16f41fd6f-1768440186961.png",
      imageAlt: '12 seater tempo traveller for Amritsar to Dharamshala'
    },
    {
      id: 2,
      name: 'Tempo Traveller',
      seats: 17,
      luggage: 15,
      price: 33000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_174173c65-1768446172648.png",
      imageAlt: '17 seater tempo traveller for Amritsar to Dharamshala'
    },
    {
      id: 3,
      name: 'Tempo Traveller',
      seats: 25,
      luggage: 15,
      price: 41800,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1d5c50116-1768362509960.png",
      imageAlt: '25 seater tempo traveller for Amritsar to Dharamshala'
    },
    {
      id: 4,
      name: 'Force Urbania',
      seats: 16,
      luggage: 16,
      price: 41800,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_15436b54b-1768446172655.png",
      imageAlt: '16 seater Force Urbania for Amritsar to Dharamshala'
    }]
  },
  'amritsar-govind-ghat': {
    from: 'Amritsar',
    to: 'Govind Ghat',
    fareStart: 84000,
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    dayOptions: ['4N 5D', '5N 6D', '6N 7D', '7N 8D'],
    vehicles: [
    {
      id: 1,
      name: 'Tempo Traveller',
      seats: 12,
      luggage: 8,
      price: 84000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1b08f4215-1768440186949.png",
      imageAlt: '12 seater tempo traveller for Amritsar to Govind Ghat'
    },
    {
      id: 2,
      name: 'Tempo Traveller',
      seats: 17,
      luggage: 15,
      price: 90000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_11caa85c4-1768440186932.png",
      imageAlt: '17 seater tempo traveller for Amritsar to Govind Ghat'
    },
    {
      id: 3,
      name: 'Tempo Traveller',
      seats: 25,
      luggage: 15,
      price: 114000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_13a020818-1768441872052.png",
      imageAlt: '25 seater tempo traveller for Amritsar to Govind Ghat'
    },
    {
      id: 4,
      name: 'Force Urbania',
      seats: 16,
      luggage: 16,
      price: 114000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1b08f4215-1768440186949.png",
      imageAlt: '16 seater Force Urbania for Amritsar to Govind Ghat'
    }]
  },
  'amritsar-jaipur': {
    from: 'Amritsar',
    to: 'Jaipur',
    fareStart: 47600,
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    dayOptions: ['3N 4D', '4N 5D', '5N 6D', '6N 7D'],
    vehicles: [
    {
      id: 1,
      name: 'Tempo Traveller',
      seats: 12,
      luggage: 8,
      price: 47600,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_171c6b932-1768440186701.png",
      imageAlt: '12 seater tempo traveller for Amritsar to Jaipur'
    },
    {
      id: 2,
      name: 'Tempo Traveller',
      seats: 17,
      luggage: 15,
      price: 51000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_171c6b932-1768440186701.png",
      imageAlt: '17 seater tempo traveller for Amritsar to Jaipur'
    },
    {
      id: 3,
      name: 'Tempo Traveller',
      seats: 25,
      luggage: 15,
      price: 64600,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_171c6b932-1768440186701.png",
      imageAlt: '25 seater tempo traveller for Amritsar to Jaipur'
    },
    {
      id: 4,
      name: 'Force Urbania',
      seats: 16,
      luggage: 16,
      price: 64600,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1e683c4c0-1768529841444.png",
      imageAlt: '16 seater Force Urbania for Amritsar to Jaipur'
    }]
  },
  'amritsar-jim-corbett': {
    from: 'Amritsar',
    to: 'Jim Corbett',
    fareStart: 47600,
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    dayOptions: ['3N 4D', '4N 5D', '5N 6D', '6N 7D'],
    vehicles: [
    {
      id: 1,
      name: 'Tempo Traveller',
      seats: 12,
      luggage: 8,
      price: 47600,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1f1942669-1768440186993.png",
      imageAlt: '12 seater tempo traveller for Amritsar to Jim Corbett'
    },
    {
      id: 2,
      name: 'Tempo Traveller',
      seats: 17,
      luggage: 15,
      price: 51000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_170a50dad-1768446172885.png",
      imageAlt: '17 seater tempo traveller for Amritsar to Jim Corbett'
    },
    {
      id: 3,
      name: 'Tempo Traveller',
      seats: 25,
      luggage: 15,
      price: 64600,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_11d668f2d-1768440186997.png",
      imageAlt: '25 seater tempo traveller for Amritsar to Jim Corbett'
    },
    {
      id: 4,
      name: 'Force Urbania',
      seats: 16,
      luggage: 16,
      price: 64600,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1be0024a8-1767645973805.png",
      imageAlt: '16 seater Force Urbania for Amritsar to Jim Corbett'
    }]
  },
  'amritsar-kasauli': {
    from: 'Amritsar',
    to: 'Kasauli',
    fareStart: 47600,
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    dayOptions: ['1N 2D', '2N 3D', '3N 4D', '4N 5D'],
    vehicles: [
    {
      id: 1,
      name: 'Tempo Traveller',
      seats: 12,
      luggage: 8,
      price: 47600,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_14dbba4f3-1768440186846.png",
      imageAlt: '12 seater tempo traveller for Amritsar to Kasauli'
    },
    {
      id: 2,
      name: 'Tempo Traveller',
      seats: 17,
      luggage: 15,
      price: 51000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_14dbba4f3-1768440186846.png",
      imageAlt: '17 seater tempo traveller for Amritsar to Kasauli'
    },
    {
      id: 3,
      name: 'Tempo Traveller',
      seats: 25,
      luggage: 15,
      price: 64600,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_14dbba4f3-1768440186846.png",
      imageAlt: '25 seater tempo traveller for Amritsar to Kasauli'
    },
    {
      id: 4,
      name: 'Force Urbania',
      seats: 16,
      luggage: 16,
      price: 64600,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1644f1da7-1768446172234.png",
      imageAlt: '16 seater Force Urbania for Amritsar to Kasauli'
    }]
  },
  'amritsar-kashmir': {
    from: 'Amritsar',
    to: 'Kashmir',
    fareStart: 42000,
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    dayOptions: ['4N 5D', '5N 6D', '6N 7D', '7N 8D', '8N 9D'],
    vehicles: [
    {
      id: 1,
      name: 'Tempo Traveller',
      seats: 12,
      luggage: 8,
      price: 42000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_16f41fd6f-1768440186961.png",
      imageAlt: '12 seater tempo traveller for Amritsar to Kashmir'
    },
    {
      id: 2,
      name: 'Tempo Traveller',
      seats: 17,
      luggage: 15,
      price: 45000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_19f232574-1768446172689.png",
      imageAlt: '17 seater tempo traveller for Amritsar to Kashmir'
    },
    {
      id: 3,
      name: 'Tempo Traveller',
      seats: 25,
      luggage: 15,
      price: 57000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1c9cda077-1768440186981.png",
      imageAlt: '25 seater tempo traveller for Amritsar to Kashmir'
    },
    {
      id: 4,
      name: 'Force Urbania',
      seats: 16,
      luggage: 16,
      price: 57000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_18ecbb159-1768520248568.png",
      imageAlt: '16 seater Force Urbania for Amritsar to Kashmir'
    }]
  },

  // Mohali Routes
  'mohali-delhi': {
    from: 'Mohali',
    to: 'Delhi',
    fareStart: 14000,
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    dayOptions: ['1D', '1N 2D', '2N 3D'],
    vehicles: [
    {
      id: 1,
      name: 'Tempo Traveller',
      seats: 12,
      luggage: 8,
      price: 14000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_11d668f2d-1768440186997.png",
      imageAlt: '12 seater tempo traveller for Mohali to Delhi'
    },
    {
      id: 2,
      name: 'Tempo Traveller',
      seats: 17,
      luggage: 15,
      price: 15000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_16db0878c-1768446170571.png",
      imageAlt: '17 seater tempo traveller for Mohali to Delhi'
    },
    {
      id: 3,
      name: 'Force Urbania',
      seats: 16,
      luggage: 16,
      price: 19000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1d9d3fe65-1768446170258.png",
      imageAlt: 'Force Urbania for Mohali to Delhi'
    },
    {
      id: 4,
      name: 'Tempo Traveller',
      seats: 25,
      luggage: 15,
      price: 19000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1644f1da7-1768446172234.png",
      imageAlt: '25 seater tempo traveller for Mohali to Delhi'
    }]

  },
  'mohali-delhi-airport': {
    from: 'Mohali',
    to: 'Delhi Airport',
    fareStart: 14000,
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    dayOptions: ['1D', '1N 2D', '2N 3D'],
    vehicles: [
    {
      id: 1,
      name: 'Tempo Traveller',
      seats: 12,
      luggage: 8,
      price: 14000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_16f41fd6f-1768440186961.png",
      imageAlt: '12 seater tempo traveller for Mohali to Delhi Airport'
    },
    {
      id: 2,
      name: 'Tempo Traveller',
      seats: 17,
      luggage: 15,
      price: 15000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_15436b54b-1768446172655.png",
      imageAlt: '17 seater tempo traveller for Mohali to Delhi Airport'
    },
    {
      id: 3,
      name: 'Force Urbania',
      seats: 16,
      luggage: 16,
      price: 19000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1cbebf900-1765191978518.png",
      imageAlt: 'Force Urbania for Mohali to Delhi Airport'
    },
    {
      id: 4,
      name: 'Tempo Traveller',
      seats: 25,
      luggage: 15,
      price: 19000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_19f232574-1768446172689.png",
      imageAlt: '25 seater tempo traveller for Mohali to Delhi Airport'
    }]

  },
  'mohali-khatu-shyam': {
    from: 'Mohali',
    to: 'Khatu Shyam',
    fareStart: 33600,
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    dayOptions: ['1N 2D', '2N 3D', '3N 4D', '4N 5D'],
    vehicles: [
    {
      id: 1,
      name: 'Tempo Traveller',
      seats: 12,
      luggage: 8,
      price: 33600,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1644f1da7-1768446172234.png",
      imageAlt: '12 seater tempo traveller for Mohali to Khatu Shyam'
    },
    {
      id: 2,
      name: 'Tempo Traveller',
      seats: 17,
      luggage: 15,
      price: 36000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_183d41f7a-1768446172603.png",
      imageAlt: '17 seater tempo traveller for Mohali to Khatu Shyam'
    },
    {
      id: 3,
      name: 'Force Urbania',
      seats: 16,
      luggage: 16,
      price: 45600,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_15436b54b-1768446172655.png",
      imageAlt: 'Force Urbania for Mohali to Khatu Shyam'
    },
    {
      id: 4,
      name: 'Tempo Traveller',
      seats: 25,
      luggage: 15,
      price: 45600,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1d461a4d4-1768082329835.png",
      imageAlt: '25 seater tempo traveller for Mohali to Khatu Shyam'
    }]

  },
  'mohali-salasar-balaji': {
    from: 'Mohali',
    to: 'Salasar Balaji',
    fareStart: 33600,
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    dayOptions: ['1N 2D', '2N 3D', '3N 4D', '4N 5D'],
    vehicles: [
    {
      id: 1,
      name: 'Tempo Traveller',
      seats: 12,
      luggage: 8,
      price: 33600,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_170a50dad-1768446172885.png",
      imageAlt: '12 seater tempo traveller for Mohali to Salasar Balaji'
    },
    {
      id: 2,
      name: 'Tempo Traveller',
      seats: 17,
      luggage: 15,
      price: 36000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_170a50dad-1768446172885.png",
      imageAlt: '17 seater tempo traveller for Mohali to Salasar Balaji'
    },
    {
      id: 3,
      name: 'Force Urbania',
      seats: 16,
      luggage: 16,
      price: 45600,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_16f41fd6f-1768440186961.png",
      imageAlt: 'Force Urbania for Mohali to Salasar Balaji'
    },
    {
      id: 4,
      name: 'Tempo Traveller',
      seats: 25,
      luggage: 15,
      price: 45600,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_170a50dad-1768446172885.png",
      imageAlt: '25 seater tempo traveller for Mohali to Salasar Balaji'
    }]

  },
  'mohali-manali': {
    from: 'Mohali',
    to: 'Manali',
    fareStart: 33600,
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    dayOptions: ['2N 3D', '3N 4D', '4N 5D', '5N 6D', '6N 7D', '7N 8D'],
    vehicles: [
    {
      id: 1,
      name: 'Tempo Traveller',
      seats: 12,
      luggage: 8,
      price: 33600,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1d9d3fe65-1768446170258.png",
      imageAlt: '12 seater tempo traveller for Mohali to Manali'
    },
    {
      id: 2,
      name: 'Tempo Traveller',
      seats: 17,
      luggage: 15,
      price: 36000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_16db0878c-1768446170571.png",
      imageAlt: '17 seater tempo traveller for Mohali to Manali'
    },
    {
      id: 3,
      name: 'Force Urbania',
      seats: 16,
      luggage: 16,
      price: 45600,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1ef04795b-1768380108447.png",
      imageAlt: 'Force Urbania for Mohali to Manali'
    },
    {
      id: 4,
      name: 'Tempo Traveller',
      seats: 25,
      luggage: 15,
      price: 45600,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_16db0878c-1768446170571.png",
      imageAlt: '25 seater tempo traveller for Mohali to Manali'
    }]

  },
  'mohali-himachal-pradesh': {
    from: 'Mohali',
    to: 'Himachal Pradesh',
    fareStart: 19600,
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    dayOptions: ['1N 2D', '2N 3D', '3N 4D', '4N 5D', '5N 6D', '6N 7D', '7N 8D', '8N 9D', '9N 10D'],
    vehicles: [
    {
      id: 1,
      name: 'Tempo Traveller',
      seats: 12,
      luggage: 8,
      price: 19600,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_170a50dad-1768446172885.png",
      imageAlt: '12 seater tempo traveller for Mohali to Himachal Pradesh'
    },
    {
      id: 2,
      name: 'Tempo Traveller',
      seats: 17,
      luggage: 15,
      price: 21000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_16db0878c-1768446170571.png",
      imageAlt: '17 seater tempo traveller for Mohali to Himachal Pradesh'
    },
    {
      id: 3,
      name: 'Force Urbania',
      seats: 16,
      luggage: 16,
      price: 26600,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1e683c4c0-1768529841444.png",
      imageAlt: 'Force Urbania for Mohali to Himachal Pradesh'
    },
    {
      id: 4,
      name: 'Tempo Traveller',
      seats: 25,
      luggage: 15,
      price: 26600,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_183d41f7a-1768446172603.png",
      imageAlt: '25 seater tempo traveller for Mohali to Himachal Pradesh'
    }]

  },
  'mohali-mussoorie': {
    from: 'Mohali',
    to: 'Mussoorie',
    fareStart: 22400,
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    dayOptions: ['1N 2D', '2N 3D', '3N 4D', '4N 5D'],
    vehicles: [
    {
      id: 1,
      name: 'Tempo Traveller',
      seats: 12,
      luggage: 8,
      price: 22400,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_170a50dad-1768446172885.png",
      imageAlt: '12 seater tempo traveller for Mohali to Mussoorie'
    },
    {
      id: 2,
      name: 'Tempo Traveller',
      seats: 17,
      luggage: 15,
      price: 24000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_17e05246a-1768446172520.png",
      imageAlt: '17 seater tempo traveller for Mohali to Mussoorie'
    },
    {
      id: 3,
      name: 'Force Urbania',
      seats: 16,
      luggage: 16,
      price: 30400,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1644f1da7-1768446172234.png",
      imageAlt: 'Force Urbania for Mohali to Mussoorie'
    },
    {
      id: 4,
      name: 'Tempo Traveller',
      seats: 25,
      luggage: 15,
      price: 30400,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1d9d3fe65-1768446170258.png",
      imageAlt: '25 seater tempo traveller for Mohali to Mussoorie'
    }]

  },
  'mohali-dharamshala': {
    from: 'Mohali',
    to: 'Dharamshala',
    fareStart: 21000,
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    dayOptions: ['2N 3D', '3N 4D', '4N 5D', '5N 6D', '6N 7D', '7N 8D'],
    vehicles: [
    {
      id: 1,
      name: 'Tempo Traveller',
      seats: 12,
      luggage: 8,
      price: 21000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1d9d3fe65-1768446170258.png",
      imageAlt: '12 seater tempo traveller for Mohali to Dharamshala'
    },
    {
      id: 2,
      name: 'Tempo Traveller',
      seats: 17,
      luggage: 15,
      price: 22500,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_16db0878c-1768446170571.png",
      imageAlt: '17 seater tempo traveller for Mohali to Dharamshala'
    },
    {
      id: 3,
      name: 'Force Urbania',
      seats: 16,
      luggage: 16,
      price: 28500,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_16db0878c-1768446170571.png",
      imageAlt: 'Force Urbania for Mohali to Dharamshala'
    },
    {
      id: 4,
      name: 'Tempo Traveller',
      seats: 25,
      luggage: 15,
      price: 28500,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1d9d3fe65-1768446170258.png",
      imageAlt: '25 seater tempo traveller for Mohali to Dharamshala'
    }]

  },
  'mohali-kasol': {
    from: 'Mohali',
    to: 'Kasol',
    fareStart: 22400,
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    dayOptions: ['2N 3D', '3N 4D', '4N 5D'],
    vehicles: [
    {
      id: 1,
      name: 'Tempo Traveller',
      seats: 12,
      luggage: 8,
      price: 22400,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_16db0878c-1768446170571.png",
      imageAlt: '12 seater tempo traveller for Mohali to Kasol'
    },
    {
      id: 2,
      name: 'Tempo Traveller',
      seats: 17,
      luggage: 15,
      price: 24000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_16db0878c-1768446170571.png",
      imageAlt: '17 seater tempo traveller for Mohali to Kasol'
    },
    {
      id: 3,
      name: 'Tempo Traveller',
      seats: 25,
      luggage: 15,
      price: 30400,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1a145f942-1768447884817.png",
      imageAlt: '25 seater tempo traveller for Mohali to Kasol'
    },
    {
      id: 4,
      name: 'Force Urbania',
      seats: 16,
      luggage: 16,
      price: 30400,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1e683c4c0-1768529841444.png",
      imageAlt: 'Force Urbania for Mohali to Kasol'
    }]
  },
  'mohali-khatu-shyam': {
    from: 'Mohali',
    to: 'Khatu Shyam',
    fareStart: 22400,
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    dayOptions: ['1D', '1N 2D', '2N 3D'],
    vehicles: [
    {
      id: 1,
      name: 'Tempo Traveller',
      seats: 12,
      luggage: 8,
      price: 22400,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1644f1da7-1768446172234.png",
      imageAlt: '12 seater tempo traveller for Mohali to Khatu Shyam'
    },
    {
      id: 2,
      name: 'Tempo Traveller',
      seats: 17,
      luggage: 15,
      price: 24000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1644f1da7-1768446172234.png",
      imageAlt: '17 seater tempo traveller for Mohali to Khatu Shyam'
    },
    {
      id: 3,
      name: 'Tempo Traveller',
      seats: 25,
      luggage: 15,
      price: 30400,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1644f1da7-1768446172234.png",
      imageAlt: '25 seater tempo traveller for Mohali to Khatu Shyam'
    },
    {
      id: 4,
      name: 'Force Urbania',
      seats: 16,
      luggage: 16,
      price: 30400,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1d461a4d4-1768082329835.png",
      imageAlt: 'Force Urbania for Mohali to Khatu Shyam'
    }]
  },
  'mohali-mathura': {
    from: 'Mohali',
    to: 'Mathura',
    fareStart: 22400,
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    dayOptions: ['1D', '1N 2D', '2N 3D'],
    vehicles: [
    {
      id: 1,
      name: 'Tempo Traveller',
      seats: 12,
      luggage: 8,
      price: 22400,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_11d668f2d-1768440186997.png",
      imageAlt: '12 seater tempo traveller for Mohali to Mathura'
    },
    {
      id: 2,
      name: 'Tempo Traveller',
      seats: 17,
      luggage: 15,
      price: 24000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_188d54dc6-1768446169568.png",
      imageAlt: '17 seater tempo traveller for Mohali to Mathura'
    },
    {
      id: 3,
      name: 'Tempo Traveller',
      seats: 25,
      luggage: 15,
      price: 30400,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_168e77c63-1768440186935.png",
      imageAlt: '25 seater tempo traveller for Mohali to Mathura'
    },
    {
      id: 4,
      name: 'Force Urbania',
      seats: 16,
      luggage: 16,
      price: 30400,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_15436b54b-1768446172655.png",
      imageAlt: 'Force Urbania for Mohali to Mathura'
    }]
  },
  'mohali-vrindavan': {
    from: 'Mohali',
    to: 'Vrindavan',
    fareStart: 16800,
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    dayOptions: ['1D', '1N 2D', '2N 3D'],
    vehicles: [
    {
      id: 1,
      name: 'Tempo Traveller',
      seats: 12,
      luggage: 8,
      price: 16800,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_170a50dad-1768446172885.png",
      imageAlt: '12 seater tempo traveller for Mohali to Vrindavan'
    },
    {
      id: 2,
      name: 'Tempo Traveller',
      seats: 17,
      luggage: 15,
      price: 18000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_16db0878c-1768446170571.png",
      imageAlt: '17 seater tempo traveller for Mohali to Vrindavan'
    },
    {
      id: 3,
      name: 'Force Urbania',
      seats: 16,
      luggage: 16,
      price: 22800,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1d461a4d4-1768082329835.png",
      imageAlt: 'Force Urbania for Mohali to Vrindavan'
    },
    {
      id: 4,
      name: 'Tempo Traveller',
      seats: 25,
      luggage: 15,
      price: 22800,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_16ec77c72-1768446172526.png",
      imageAlt: '25 seater tempo traveller for Mohali to Vrindavan'
    }]
  },

  // Patiala Routes
  'patiala-khatu-shyam': {
    from: 'Patiala',
    to: 'Khatu Shyam',
    fareStart: 30800,
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    dayOptions: ['1N 2D', '2N 3D', '3N 4D', '4N 5D'],
    vehicles: [
    {
      id: 1,
      name: 'Tempo Traveller',
      seats: 12,
      luggage: 8,
      price: 30800,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1644f1da7-1768446172234.png",
      imageAlt: '12 seater tempo traveller for Patiala to Khatu Shyam'
    },
    {
      id: 2,
      name: 'Tempo Traveller',
      seats: 17,
      luggage: 15,
      price: 33000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_15436b54b-1768446172655.png",
      imageAlt: '17 seater tempo traveller for Patiala to Khatu Shyam'
    },
    {
      id: 3,
      name: 'Force Urbania',
      seats: 16,
      luggage: 16,
      price: 41800,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_13dbe834c-1768440184022.png",
      imageAlt: 'Force Urbania for Patiala to Khatu Shyam'
    },
    {
      id: 4,
      name: 'Tempo Traveller',
      seats: 25,
      luggage: 15,
      price: 41800,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_183d41f7a-1768446172603.png",
      imageAlt: '25 seater tempo traveller for Patiala to Khatu Shyam'
    }]

  },
  'patiala-salasar-balaji': {
    from: 'Patiala',
    to: 'Salasar Balaji',
    fareStart: 30800,
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    dayOptions: ['1N 2D', '2N 3D', '3N 4D', '4N 5D'],
    vehicles: [
    {
      id: 1,
      name: 'Tempo Traveller',
      seats: 12,
      luggage: 8,
      price: 30800,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_15436b54b-1768446172655.png",
      imageAlt: '12 seater tempo traveller for Patiala to Salasar Balaji'
    },
    {
      id: 2,
      name: 'Tempo Traveller',
      seats: 17,
      luggage: 15,
      price: 33000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1d9d3fe65-1768446170258.png",
      imageAlt: '17 seater tempo traveller for Patiala to Salasar Balaji'
    },
    {
      id: 3,
      name: 'Force Urbania',
      seats: 16,
      luggage: 16,
      price: 41800,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_188d54dc6-1768446169568.png",
      imageAlt: 'Force Urbania for Patiala to Salasar Balaji'
    },
    {
      id: 4,
      name: 'Tempo Traveller',
      seats: 25,
      luggage: 15,
      price: 41800,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1d9d3fe65-1768446170258.png",
      imageAlt: '25 seater tempo traveller for Patiala to Salasar Balaji'
    }]

  },
  'patiala-amritsar': {
    from: 'Patiala',
    to: 'Amritsar',
    fareStart: 14560,
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    dayOptions: ['1D', '1N 2D', '2N 3D'],
    vehicles: [
    {
      id: 1,
      name: 'Tempo Traveller',
      seats: 12,
      luggage: 8,
      price: 14560,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_15436b54b-1768446172655.png",
      imageAlt: '12 seater tempo traveller for Patiala to Amritsar'
    },
    {
      id: 2,
      name: 'Tempo Traveller',
      seats: 17,
      luggage: 15,
      price: 15600,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1d9d3fe65-1768446170258.png",
      imageAlt: '17 seater tempo traveller for Patiala to Amritsar'
    },
    {
      id: 3,
      name: 'Tempo Traveller',
      seats: 25,
      luggage: 15,
      price: 19760,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_17e05246a-1768446172520.png",
      imageAlt: '25 seater tempo traveller for Patiala to Amritsar'
    },
    {
      id: 4,
      name: 'Force Urbania',
      seats: 16,
      luggage: 16,
      price: 19760,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1d5c50116-1768362509960.png",
      imageAlt: '16 seater Force Urbania for Patiala to Amritsar'
    }]
  },
  'patiala-amritsar-sahib': {
    from: 'Patiala',
    to: 'Amritsar Sahib',
    fareStart: 14560,
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    dayOptions: ['1D', '1N 2D', '2N 3D'],
    vehicles: [
    {
      id: 1,
      name: 'Tempo Traveller',
      seats: 12,
      luggage: 8,
      price: 14560,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1d9d3fe65-1768446170258.png",
      imageAlt: '12 seater tempo traveller for Patiala to Amritsar Sahib'
    },
    {
      id: 2,
      name: 'Tempo Traveller',
      seats: 17,
      luggage: 15,
      price: 15600,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_174173c65-1768446172648.png",
      imageAlt: '17 seater tempo traveller for Patiala to Amritsar Sahib'
    },
    {
      id: 3,
      name: 'Tempo Traveller',
      seats: 25,
      luggage: 15,
      price: 19760,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_13dbe834c-1768440184022.png",
      imageAlt: '25 seater tempo traveller for Patiala to Amritsar Sahib'
    },
    {
      id: 4,
      name: 'Force Urbania',
      seats: 16,
      luggage: 16,
      price: 19760,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_11d668f2d-1768440186997.png",
      imageAlt: '16 seater Force Urbania for Patiala to Amritsar Sahib'
    }]
  },
  'patiala-agra': {
    from: 'Patiala',
    to: 'Agra',
    fareStart: 30800,
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    dayOptions: ['1N 2D', '2N 3D', '3N 4D', '4N 5D', '5N 6D', '6N 7D'],
    vehicles: [
    {
      id: 1,
      name: 'Tempo Traveller',
      seats: 12,
      luggage: 8,
      price: 30800,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1390400ab-1768447858097.png",
      imageAlt: '12 seater tempo traveller for Patiala to Agra'
    },
    {
      id: 2,
      name: 'Tempo Traveller',
      seats: 17,
      luggage: 15,
      price: 33000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1390400ab-1768447858097.png",
      imageAlt: '17 seater tempo traveller for Patiala to Agra'
    },
    {
      id: 3,
      name: 'Tempo Traveller',
      seats: 25,
      luggage: 15,
      price: 41800,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_168e77c63-1768440186935.png",
      imageAlt: '25 seater tempo traveller for Patiala to Agra'
    },
    {
      id: 4,
      name: 'Force Urbania',
      seats: 16,
      luggage: 16,
      price: 41800,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1e683c4c0-1768529841444.png",
      imageAlt: '16 seater Force Urbania for Patiala to Agra'
    }]
  },
  'patiala-amarnath': {
    from: 'Patiala',
    to: 'Amarnath',
    fareStart: 44800,
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    dayOptions: ['4N 5D', '5N 6D', '6N 7D', '7N 8D', '8N 9D'],
    vehicles: [
    {
      id: 1,
      name: 'Tempo Traveller',
      seats: 12,
      luggage: 8,
      price: 44800,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_174173c65-1768446172648.png",
      imageAlt: '12 seater tempo traveller for Patiala to Amarnath'
    },
    {
      id: 2,
      name: 'Tempo Traveller',
      seats: 17,
      luggage: 15,
      price: 48000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_174173c65-1768446172648.png",
      imageAlt: '17 seater tempo traveller for Patiala to Amarnath'
    },
    {
      id: 3,
      name: 'Tempo Traveller',
      seats: 25,
      luggage: 15,
      price: 60800,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1d9d3fe65-1768446170258.png",
      imageAlt: '25 seater tempo traveller for Patiala to Amarnath'
    },
    {
      id: 4,
      name: 'Force Urbania',
      seats: 16,
      luggage: 16,
      price: 60800,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1d461a4d4-1768082329835.png",
      imageAlt: '16 seater Force Urbania for Patiala to Amarnath'
    }]
  },
  'patiala-ayodhya': {
    from: 'Patiala',
    to: 'Ayodhya',
    fareStart: 67200,
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    dayOptions: ['4N 5D', '5N 6D', '6N 7D', '7N 8D', '8N 9D'],
    vehicles: [
    {
      id: 1,
      name: 'Tempo Traveller',
      seats: 12,
      luggage: 8,
      price: 67200,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1d461a4d4-1768082329835.png",
      imageAlt: '12 seater tempo traveller for Patiala to Ayodhya'
    },
    {
      id: 2,
      name: 'Tempo Traveller',
      seats: 17,
      luggage: 15,
      price: 72000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1d9d3fe65-1768446170258.png",
      imageAlt: '17 seater tempo traveller for Patiala to Ayodhya'
    },
    {
      id: 3,
      name: 'Tempo Traveller',
      seats: 25,
      luggage: 15,
      price: 91200,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1390400ab-1768447858097.png",
      imageAlt: '25 seater tempo traveller for Patiala to Ayodhya'
    },
    {
      id: 4,
      name: 'Force Urbania',
      seats: 16,
      luggage: 16,
      price: 91200,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1d461a4d4-1768082329835.png",
      imageAlt: '16 seater Force Urbania for Patiala to Ayodhya'
    }]
  },
  'patiala-char-dham': {
    from: 'Patiala',
    to: 'Char Dham',
    fareStart: 70000,
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    dayOptions: ['5N 6D', '6N 7D', '7N 8D', '8N 9D', '9N 10D'],
    vehicles: [
    {
      id: 1,
      name: 'Tempo Traveller',
      seats: 12,
      luggage: 8,
      price: 70000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1d9d3fe65-1768446170258.png",
      imageAlt: '12 seater tempo traveller for Patiala to Char Dham'
    },
    {
      id: 2,
      name: 'Tempo Traveller',
      seats: 17,
      luggage: 15,
      price: 75000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1d9d3fe65-1768446170258.png",
      imageAlt: '17 seater tempo traveller for Patiala to Char Dham'
    },
    {
      id: 3,
      name: 'Tempo Traveller',
      seats: 25,
      luggage: 15,
      price: 95000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1d9d3fe65-1768446170258.png",
      imageAlt: '25 seater tempo traveller for Patiala to Char Dham'
    },
    {
      id: 4,
      name: 'Force Urbania',
      seats: 16,
      luggage: 16,
      price: 95000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_18ecbb159-1768520248568.png",
      imageAlt: '16 seater Force Urbania for Patiala to Char Dham'
    }]
  },
  'patiala-badrinath-kedarnath': {
    from: 'Patiala',
    to: 'Badrinath Kedarnath',
    fareStart: 70000,
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    dayOptions: ['5N 6D', '6N 7D', '7N 8D', '8N 9D', '9N 10D'],
    vehicles: [
    {
      id: 1,
      name: 'Tempo Traveller',
      seats: 12,
      luggage: 8,
      price: 70000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1d9d3fe65-1768446170258.png",
      imageAlt: '12 seater tempo traveller for Patiala to Badrinath Kedarnath'
    },
    {
      id: 2,
      name: 'Tempo Traveller',
      seats: 17,
      luggage: 15,
      price: 75000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1d9d3fe65-1768446170258.png",
      imageAlt: '17 seater tempo traveller for Patiala to Badrinath Kedarnath'
    },
    {
      id: 3,
      name: 'Tempo Traveller',
      seats: 25,
      luggage: 15,
      price: 95000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1cc5e2f9b-1768447111427.png",
      imageAlt: '25 seater tempo traveller for Patiala to Badrinath Kedarnath'
    },
    {
      id: 4,
      name: 'Force Urbania',
      seats: 16,
      luggage: 16,
      price: 95000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1e683c4c0-1768529841444.png",
      imageAlt: '16 seater Force Urbania for Patiala to Badrinath Kedarnath'
    }]
  },
  'patiala-dalhousie': {
    from: 'Patiala',
    to: 'Dalhousie',
    fareStart: 33600,
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    dayOptions: ['2N 3D', '3N 4D', '4N 5D'],
    vehicles: [
    {
      id: 1,
      name: 'Tempo Traveller',
      seats: 12,
      luggage: 8,
      price: 33600,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1d9d3fe65-1768446170258.png",
      imageAlt: '12 seater tempo traveller for Patiala to Dalhousie'
    },
    {
      id: 2,
      name: 'Tempo Traveller',
      seats: 17,
      luggage: 15,
      price: 36000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1d9d3fe65-1768446170258.png",
      imageAlt: '17 seater tempo traveller for Patiala to Dalhousie'
    },
    {
      id: 3,
      name: 'Tempo Traveller',
      seats: 25,
      luggage: 15,
      price: 45600,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1d9d3fe65-1768446170258.png",
      imageAlt: '25 seater tempo traveller for Patiala to Dalhousie'
    },
    {
      id: 4,
      name: 'Force Urbania',
      seats: 16,
      luggage: 16,
      price: 45600,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1e683c4c0-1768529841444.png",
      imageAlt: '16 seater Force Urbania for Patiala to Dalhousie'
    }]
  },
  'patiala-dharamshala': {
    from: 'Patiala',
    to: 'Dharamshala',
    fareStart: 33600,
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    dayOptions: ['2N 3D', '3N 4D', '4N 5D'],
    vehicles: [
    {
      id: 1,
      name: 'Tempo Traveller',
      seats: 12,
      luggage: 8,
      price: 33600,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1e683c4c0-1768529841444.png",
      imageAlt: '12 seater tempo traveller for Patiala to Dharamshala'
    },
    {
      id: 2,
      name: 'Tempo Traveller',
      seats: 17,
      luggage: 15,
      price: 36000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_174173c65-1768446172648.png",
      imageAlt: '17 seater tempo traveller for Patiala to Dharamshala'
    },
    {
      id: 3,
      name: 'Tempo Traveller',
      seats: 25,
      luggage: 15,
      price: 45600,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1d9d3fe65-1768446170258.png",
      imageAlt: '25 seater tempo traveller for Patiala to Dharamshala'
    },
    {
      id: 4,
      name: 'Force Urbania',
      seats: 16,
      luggage: 16,
      price: 45600,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1d9d3fe65-1768446170258.png",
      imageAlt: '16 seater Force Urbania for Patiala to Dharamshala'
    }]
  },
  'patiala-golden-temple-amritsar': {
    from: 'Patiala',
    to: 'Golden Temple Amritsar',
    fareStart: 15120,
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    dayOptions: ['1D', '1N 2D', '2N 3D'],
    vehicles: [
    {
      id: 1,
      name: 'Tempo Traveller',
      seats: 12,
      luggage: 8,
      price: 15120,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1d9d3fe65-1768446170258.png",
      imageAlt: '12 seater tempo traveller for Patiala to Golden Temple Amritsar'
    },
    {
      id: 2,
      name: 'Tempo Traveller',
      seats: 17,
      luggage: 15,
      price: 16200,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1d9d3fe65-1768446170258.png",
      imageAlt: '17 seater tempo traveller for Patiala to Golden Temple Amritsar'
    },
    {
      id: 3,
      name: 'Tempo Traveller',
      seats: 25,
      luggage: 15,
      price: 20520,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1d5c50116-1768362509960.png",
      imageAlt: '25 seater tempo traveller for Patiala to Golden Temple Amritsar'
    },
    {
      id: 4,
      name: 'Force Urbania',
      seats: 16,
      luggage: 16,
      price: 20520,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1d461a4d4-1768082329835.png",
      imageAlt: '16 seater Force Urbania for Patiala to Golden Temple Amritsar'
    }]
  }
};

// Visitor guide content for each route with destination highlights, travel tips, and route-specific information
export const routeVisitorGuides = {
  // Delhi Routes
  'delhi-amritsar': {
    title: 'Delhi to Amritsar - Journey to the Golden Temple',
    introduction: 'Embark on a spiritual and cultural journey from India\'s capital to the heart of Sikhism. The 450 km route from Delhi to Amritsar takes you through the vibrant landscapes of Punjab, offering glimpses of rural life, lush green fields, and the warm hospitality that the region is famous for.',
    highlights: [
    'Golden Temple (Harmandir Sahib) - The most sacred Gurdwara of Sikhism, a stunning architectural marvel covered in gold',
    'Jallianwala Bagh - Historic memorial commemorating the 1919 massacre',
    'Wagah Border - Witness the famous beating retreat ceremony between India and Pakistan',
    'Partition Museum - Learn about the 1947 partition through personal stories and artifacts',
    'Gobindgarh Fort - Experience Punjab\'s rich history through light and sound shows'],

    travelTips: [
    'Best time to visit: October to March for pleasant weather',
    'The journey takes approximately 7-8 hours via NH44',
    'Book langar (community meal) at Golden Temple - it\'s free and a unique experience',
    'Wagah Border ceremony starts at 4:15 PM in winter and 5:15 PM in summer',
    'Try authentic Punjabi cuisine - Amritsari kulcha, lassi, and fish are must-tries'],

    routeInfo: 'The route passes through Panipat, Karnal, Ambala, and Ludhiana. Multiple rest stops and dhabas are available for refreshments.'
  },
  'delhi-manali': {
    title: 'Delhi to Manali - Gateway to the Himalayas',
    introduction: 'Experience the dramatic transformation from urban Delhi to the snow-capped peaks of Manali. This 540 km journey takes you through diverse landscapes - from plains to foothills to high mountains, offering breathtaking views at every turn.',
    highlights: [
    'Solang Valley - Adventure sports hub with paragliding, zorbing, and skiing',
    'Rohtang Pass - Snow-covered mountain pass at 13,050 feet (permit required)',
    'Hadimba Temple - Ancient cave temple surrounded by cedar forests',
    'Old Manali - Bohemian cafes, live music, and hippie culture',
    'Vashisht Hot Springs - Natural sulfur springs with therapeutic properties',
    'Mall Road - Shopping and dining'],

    travelTips: [
    'Best time: April-June for pleasant weather, December-February for snow',
    'Journey takes 12-14 hours; plan for overnight stay or early morning start',
    'Carry warm clothes even in summer - temperature drops significantly',
    'Rohtang Pass permit must be booked online in advance',
    'Altitude sickness precautions - stay hydrated and avoid alcohol initially'],

    routeInfo: 'Route via NH44 and NH3 passes through Karnal, Chandigarh, Bilaspur, Mandi, and Kullu. Scenic mountain roads begin after Mandi.'
  },
  'delhi-shimla': {
    title: 'Delhi to Shimla - Queen of Hills',
    introduction: 'Journey to the former summer capital of British India, nestled in the Himalayan foothills. The 350 km route offers a perfect blend of colonial architecture, natural beauty, and pleasant mountain climate.',
    highlights: [
    'The Ridge - Central hub with panoramic mountain views and colonial buildings',
    'Mall Road - Shopping street with cafes, restaurants, and handicraft stores',
    'Jakhu Temple - Giant Hanuman statue at the highest point',
    'Christ Church - Second oldest church in North India with neo-Gothic architecture',
    'Kufri - Skiing destination',
    'Toy Train - UNESCO World Heritage Kalka-Shimla railway'],

    travelTips: [
    'Best time: March-June and September-November',
    'Journey takes 7-8 hours via NH44 and NH5',
    'Parking is limited; vehicles not allowed on Mall Road',
    'Book hotels in advance during peak season',
    'Try local delicacies - chana madra, sidu, and babru'],

    routeInfo: 'Route passes through Ambala, Kalka, and Solan. Road conditions are excellent with well-maintained highways.'
  },
  'delhi-dharamshala': {
    title: 'Delhi to Dharamshala - Home of the Dalai Lama',
    introduction: 'Travel to the spiritual heart of Tibetan Buddhism in India. This 475 km journey takes you to the serene hill station where Tibetan culture thrives, offering monasteries, mountain views, and peaceful retreats.',
    highlights: [
    'Tsuglagkhang Complex - Dalai Lama\'s temple and residence',
    'Bhagsu Waterfall - Scenic waterfall with trekking trails',
    'McLeod Ganj - Tibetan settlement with cafes, monasteries, and handicrafts',
    'Triund Trek - Popular day trek with stunning Dhauladhar range views',
    'Norbulingka Institute - Preserving Tibetan art and culture',
    'Dal Lake - Peaceful lake surrounded by deodar trees'],

    travelTips: [
    'Best time: March-June and September-November',
    'Journey takes 10-11 hours via NH44 and NH154',
    'McLeod Ganj is 9 km uphill from Dharamshala',
    'Try Tibetan cuisine - momos, thukpa, and butter tea',
    'Respect monastery timings and photography restrictions'],

    routeInfo: 'Route via Chandigarh, Ropar, and Kangra offers beautiful views of Shivalik and Dhauladhar ranges.'
  },
  'delhi-dalhousie': {
    title: 'Delhi to Dalhousie - Colonial Hill Charm',
    introduction: 'Discover the old-world charm of this British-era hill station spread across five hills. The 560 km journey offers pine-covered valleys, colonial architecture, and breathtaking Himalayan views.',
    highlights: [
    'Khajjiar - "Mini Switzerland of India" with meadows and lake',
    'Kalatop Wildlife Sanctuary - Dense deodar forests with diverse wildlife',
    'St. John\'s Church - Victorian-era church with beautiful stained glass',
    'Panchpula - Scenic spot with waterfalls and streams',
    'Dainkund Peak - Highest point with 360-degree mountain views',
    'Chamera Lake - Artificial lake perfect for boating'],

    travelTips: [
    'Best time: April-June and September-November',
    'Journey takes 11-12 hours; plan accordingly',
    'Carry warm clothes - evenings can be chilly',
    'Limited ATMs; carry sufficient cash',
    'Try local Himachali dishes - madra, bhey, and patande'],

    routeInfo: 'Route via Chandigarh, Hoshiarpur, and Pathankot. Well-maintained mountain roads.'
  },
  'delhi-mussoorie': {
    title: 'Delhi to Mussoorie - Queen of the Hills',
    introduction: 'Escape to the charming hill station known for its scenic beauty and colonial heritage. The 290 km journey offers quick access to mountain freshness, making it perfect for weekend getaways.',
    highlights: [
    'Gun Hill - Second highest point with ropeway and panoramic views',
    'Kempty Falls - Popular waterfall with swimming opportunities',
    'Mall Road - Shopping and dining with mountain backdrop',
    'Lal Tibba - Highest point with telescope facility',
    'Company Garden - Beautiful botanical garden with boating',
    'Cloud\'s End - Serene spot at the end of Mussoorie range'],

    travelTips: [
    'Best time: April-June and September-November',
    'Journey takes 6-7 hours via NH334',
    'Weekend traffic can be heavy; travel on weekdays if possible',
    'Try local street food - momos, maggi, and corn',
    'Book hotels in advance during peak season'],

    routeInfo: 'Route via Meerut, Roorkee, and Dehradun. Well-maintained roads with beautiful Doon valley views.'
  },
  'delhi-himachal-pradesh': {
    title: 'Delhi to Himachal Pradesh - Complete Mountain Experience',
    introduction: 'Explore the diverse landscapes of Himachal Pradesh, from lush valleys to snow-capped peaks. This comprehensive tour covers multiple destinations, offering adventure, spirituality, and natural beauty.',
    highlights: [
    'Multiple destinations - Shimla, Manali, Dharamshala, Dalhousie',
    'Adventure activities - Trekking, paragliding, river rafting, skiing',
    'Spiritual sites - Temples, monasteries, and pilgrimage centers',
    'Natural wonders - Valleys, waterfalls, lakes, and mountain passes',
    'Cultural experiences - Local festivals, handicrafts, and cuisine'],

    travelTips: [
    'Best time: April-June and September-November',
    'Plan 7-10 days for comprehensive coverage',
    'Pack layers - weather varies across destinations',
    'Book accommodations in advance',
    'Carry necessary permits for restricted areas'],

    routeInfo: 'Flexible itinerary covering major Himachal destinations. Routes vary based on selected places.'
  },
  'delhi-khatu-shyam': {
    title: 'Delhi to Khatu Shyam - Pilgrimage to Barbarika Temple',
    introduction: 'Undertake a spiritual journey to the famous Khatu Shyam temple in Rajasthan, dedicated to Barbarika (grandson of Bhima). The 250 km journey takes you through rural Rajasthan to this important pilgrimage site.',
    highlights: [
    'Khatu Shyam Temple - Ancient temple with black stone deity',
    'Shyam Kund - Holy water tank for ritual bathing',
    'Phalguna Mela - Grand fair during Falgun month (Feb-March)',
    'Nearby Jaipur - Pink City attractions (100 km away)',
    'Local markets - Religious items and Rajasthani handicrafts'],

    travelTips: [
    'Best time: October-March; avoid summer heat',
    'Journey takes 5-6 hours via NH48 and NH52',
    'Phalguna Mela attracts huge crowds - book accommodation early',
    'Dress modestly for temple visit',
    'Try Rajasthani thali and sweets in local restaurants'],

    routeInfo: 'Route via Gurgaon, Rewari, and Sikar. Well-connected roads through Rajasthan countryside.'
  },
  'delhi-salasar-balaji': {
    title: 'Delhi to Salasar Balaji - Divine Hanuman Temple',
    introduction: 'Visit the miraculous Salasar Balaji temple in Rajasthan, one of the most revered Hanuman temples in India. The 280 km journey through Rajasthan\'s Shekhawati region offers spiritual solace and cultural insights.',
    highlights: [
    'Salasar Balaji Temple - Famous for wish fulfillment',
    'Aarti ceremonies - Morning and evening prayers',
    'Shekhawati region - Painted havelis and frescoes',
    'Local culture - Rajasthani traditions and hospitality',
    'Nearby temples - Rani Sati Temple in Jhunjhunu'],

    travelTips: [
    'Best time: October-March for comfortable weather',
    'Journey takes 5-6 hours via NH52',
    'Tuesday and Saturday see maximum devotees',
    'Free accommodation available in dharamshalas',
    'Carry water and snacks for the journey'],

    routeInfo: 'Route via Gurgaon, Rewari, and Churu district. Roads are well-maintained with regular dhabas.'
  },
  'delhi-kasol': {
    title: 'Delhi to Kasol - Hippie Paradise in Parvati Valley',
    introduction: 'Journey to the bohemian village of Kasol, nestled in the Parvati Valley. The 500 km route takes you from urban chaos to a peaceful mountain retreat known for its Israeli cafes, trekking trails, and laid-back vibe.',
    highlights: [
    'Kasol Village - Cafes, live music, and backpacker culture',
    'Parvati River - Crystal clear river perfect for riverside camping',
    'Tosh Village - Scenic hamlet with mountain views',
    'Kheerganga Trek - Hot springs trek (12 km)',
    'Manikaran Sahib - Sikh pilgrimage site with hot springs',
    'Malana Village - Ancient village with unique culture'],

    travelTips: [
    'Best time: March-June and September-November',
    'Journey takes 12-13 hours; plan overnight stay',
    'Kasol has limited ATMs - carry cash',
    'Try Israeli cuisine in local cafes',
    'Respect local customs in Malana village'],

    routeInfo: 'Route via Chandigarh, Bilaspur, Mandi, and Bhuntar. Scenic mountain roads after Mandi.'
  },
  'delhi-mathura': {
    title: 'Delhi to Mathura - Birthplace of Lord Krishna',
    introduction: 'Embark on a spiritual journey to Mathura, the birthplace of Lord Krishna. The 150 km route is one of the shortest and most popular pilgrimage trips from Delhi, perfect for day trips or weekend visits.',
    highlights: [
    'Krishna Janmabhoomi Temple - Birthplace of Lord Krishna',
    'Dwarkadhish Temple - Magnificent temple with intricate carvings',
    'Vishram Ghat - Sacred bathing ghat on Yamuna River',
    'Govardhan Hill - Circumambulation (parikrama) site',
    'Gokul and Vrindavan - Nearby Krishna pilgrimage sites',
    'Holi celebrations - Famous for colorful festivities'],

    travelTips: [
    'Best time: October-March; Janmashtami and Holi are special',
    'Journey takes 3-4 hours via Yamuna Expressway',
    'Combine with Vrindavan visit (15 km away)',
    'Try local pedas - Mathura\'s famous sweet',
    'Dress modestly for temple visits'],

    routeInfo: 'Quick route via Yamuna Expressway. Well-connected with excellent road conditions.'
  },
  'delhi-vrindavan': {
    title: 'Delhi to Vrindavan - Land of Krishna\'s Leelas',
    introduction: 'Visit the sacred town where Lord Krishna spent his childhood. The 160 km journey takes you to a spiritual haven with thousands of temples, each narrating tales of Krishna\'s divine plays.',
    highlights: [
    'Banke Bihari Temple - Most famous Krishna temple',
    'ISKCON Temple - Modern temple with beautiful architecture',
    'Prem Mandir - Illuminated temple with stunning light shows',
    'Nidhivan - Mystical forest associated with Raas Leela',
    'Seva Kunj - Garden where Krishna performed Raas',
    'Yamuna Aarti - Evening prayer ceremony at ghats'],

    travelTips: [
    'Best time: October-March; Janmashtami is spectacular',
    'Journey takes 3-4 hours via Yamuna Expressway',
    'Banke Bihari temple gets very crowded - visit early morning',
    'Try local street food - kachori, jalebi, and lassi',
    'Combine with Mathura visit (15 km away)'],

    routeInfo: 'Route via Yamuna Expressway and NH44. Excellent road connectivity with regular facilities.'
  },

  // Chandigarh Routes
  'chandigarh-amritsar': {
    title: 'Chandigarh to Amritsar - Golden Temple Pilgrimage',
    introduction: 'A short and scenic journey from the City Beautiful to the spiritual capital of Sikhism. The 230 km route through Punjab\'s heartland offers glimpses of rural life, mustard fields, and warm Punjabi hospitality.',
    highlights: [
    'Golden Temple - Stunning gold-plated Gurdwara',
    'Jallianwala Bagh - Historical memorial',
    'Wagah Border - Indo-Pak border ceremony',
    'Partition Museum - Partition history and stories',
    'Amritsari cuisine - Kulcha, lassi, fish'],

    travelTips: [
    'Journey takes 4-5 hours via NH44',
    'Best time: October-March',
    'Cover head before entering Golden Temple',
    'Free langar available 24/7',
    'Book Wagah Border ceremony seats in advance'],

    routeInfo: 'Direct route via NH44 through Ludhiana and Jalandhar. Excellent road conditions.'
  },
  'chandigarh-dalhousie': {
    title: 'Chandigarh to Dalhousie - Colonial Hill Retreat',
    introduction: 'Escape to the serene hill station named after Lord Dalhousie. The 320 km journey takes you through Punjab plains to pine-covered Himalayan hills, offering a perfect weekend getaway.',
    highlights: [
    'Khajjiar - Mini Switzerland with meadows',
    'Kalatop Wildlife Sanctuary - Dense forests',
    'Colonial architecture - Churches and buildings',
    'Panchpula - Waterfalls and streams',
    'Dainkund Peak - Panoramic views'],

    travelTips: [
    'Journey takes 7-8 hours',
    'Best time: April-June, September-November',
    'Carry warm clothes for evenings',
    'Limited mobile connectivity in some areas',
    'Book hotels in advance during peak season'],

    routeInfo: 'Route via Hoshiarpur and Pathankot. Mountain roads begin after Pathankot.'
  },
  'chandigarh-delhi-airport': {
    title: 'Chandigarh to Delhi Airport - Convenient Airport Transfer',
    introduction: 'Hassle-free group transfer from Chandigarh to Indira Gandhi International Airport. The 250 km journey ensures comfortable travel for families and groups catching flights from Delhi.',
    highlights: [
    'Direct airport transfer - Terminal 1, 2, and 3',
    'Comfortable group travel - Families and corporate groups',
    'Luggage space - Ample room for bags',
    'Timely service - Punctual pickups and drops',
    'Professional drivers - Experienced with airport routes'],

    travelTips: [
    'Journey takes 4-5 hours via NH44',
    'Book 6-7 hours before flight for safety',
    'Carry flight tickets and IDs',
    'Rest stops available on route',
    'Track flight status for any delays'],

    routeInfo: 'Direct route via NH44 through Ambala and Panipat. Well-maintained highway.'
  },
  'chandigarh-delhi': {
    title: 'Chandigarh to Delhi - Capital Connection',
    introduction: 'Connect two major North Indian cities with comfortable group travel. The 250 km journey is perfect for family trips, corporate travel, or group outings to the national capital.',
    highlights: [
    'India Gate - Iconic war memorial',
    'Red Fort - Mughal architecture marvel',
    'Qutub Minar - UNESCO World Heritage Site',
    'Lotus Temple - Bahai House of Worship',
    'Akshardham - Modern Hindu temple complex',
    'Connaught Place - Shopping and dining hub'],

    travelTips: [
    'Journey takes 4-5 hours via NH44',
    'Best time: October-March',
    'Delhi has metro connectivity for local travel',
    'Try Delhi street food - chaat, parathas, kebabs',
    'Book hotels in advance'],

    routeInfo: 'Direct route via NH44 through Ambala, Karnal, and Panipat. Excellent highway.'
  },
  'chandigarh-dharamshala': {
    title: 'Chandigarh to Dharamshala - Tibetan Culture Hub',
    introduction: 'Journey to the home of the Dalai Lama and Tibetan government-in-exile. The 240 km route through Kangra Valley offers stunning mountain views and spiritual experiences.',
    highlights: [
    'Dalai Lama Temple - Spiritual center',
    'McLeod Ganj - Tibetan settlement',
    'Bhagsu Waterfall - Scenic trek',
    'Triund Trek - Popular day hike',
    'Tibetan cuisine - Momos, thukpa',
    'Norbulingka Institute - Tibetan arts'],

    travelTips: [
    'Journey takes 5-6 hours',
    'Best time: March-June, September-November',
    'McLeod Ganj is uphill from Dharamshala',
    'Respect monastery timings',
    'Try Tibetan butter tea'],

    routeInfo: 'Route via Ropar and Kangra. Beautiful Shivalik range views throughout.'
  },
  'chandigarh-kasol': {
    title: 'Chandigarh to Kasol - Parvati Valley Escape',
    introduction: 'Head to the backpacker paradise of Kasol in Parvati Valley. The 310 km journey takes you from urban Chandigarh to a peaceful mountain village known for its cafes and trekking trails.',
    highlights: [
    'Kasol cafes - Israeli and continental food',
    'Parvati River - Riverside camping',
    'Tosh Village - Mountain hamlet',
    'Kheerganga Trek - Hot springs',
    'Manikaran Sahib - Sikh pilgrimage',
    'Malana - Ancient village'],

    travelTips: [
    'Journey takes 7-8 hours',
    'Best time: March-June, September-November',
    'Limited ATMs - carry cash',
    'Try Israeli cuisine',
    'Book accommodations in advance'],

    routeInfo: 'Route via Bilaspur, Mandi, and Bhuntar. Scenic mountain roads after Mandi.'
  },
  'chandigarh-khatu-shyam': {
    title: 'Chandigarh to Khatu Shyam - Rajasthan Pilgrimage',
    introduction: 'Undertake a spiritual journey to the famous Khatu Shyam temple in Rajasthan. The 480 km route takes you through Haryana and Rajasthan to this important Barbarika temple.',
    highlights: [
    'Khatu Shyam Temple - Black stone deity',
    'Shyam Kund - Holy water tank',
    'Phalguna Mela - Annual fair',
    'Rajasthani culture - Local traditions',
    'Nearby Jaipur - Pink City attractions'],

    travelTips: [
    'Journey takes 9-10 hours',
    'Best time: October-March',
    'Phalguna Mela attracts huge crowds',
    'Dress modestly for temple',
    'Try Rajasthani thali'],

    routeInfo: 'Route via Ambala, Hisar, and Sikar. Long journey through Rajasthan countryside.'
  },
  'chandigarh-mathura': {
    title: 'Chandigarh to Mathura - Krishna Janmabhoomi',
    introduction: 'Visit the birthplace of Lord Krishna from Chandigarh. The 400 km journey takes you to one of Hinduism\'s most sacred cities, perfect for spiritual seekers and devotees.',
    highlights: [
    'Krishna Janmabhoomi - Birthplace temple',
    'Dwarkadhish Temple - Beautiful architecture',
    'Vishram Ghat - Sacred bathing spot',
    'Vrindavan nearby - 15 km away',
    'Govardhan Hill - Parikrama site',
    'Mathura pedas - Famous sweets'],

    travelTips: [
    'Journey takes 7-8 hours',
    'Best time: October-March',
    'Janmashtami is special time to visit',
    'Combine with Vrindavan trip',
    'Try local pedas and street food'],

    routeInfo: 'Route via Ambala, Karnal, and Yamuna Expressway. Well-connected roads.'
  },
  'chandigarh-mussoorie': {
    title: 'Chandigarh to Mussoorie - Queen of Hills',
    introduction: 'Escape to the charming hill station from Chandigarh. The 220 km journey through Doon Valley offers quick access to mountain beauty, colonial charm, and pleasant weather.',
    highlights: [
    'Gun Hill - Ropeway and views',
    'Kempty Falls - Popular waterfall',
    'Mall Road - Shopping and dining',
    'Lal Tibba - Highest point',
    'Company Garden - Botanical beauty',
    'Cloud\'s End - Serene spot'],

    travelTips: [
    'Journey takes 5-6 hours',
    'Best time: April-June, September-November',
    'Weekend traffic can be heavy',
    'Try local momos and maggi',
    'Book hotels in advance'],

    routeInfo: 'Route via Yamuna Nagar, Paonta Sahib, and Dehradun. Beautiful valley views.'
  },
  'chandigarh-salasar-balaji': {
    title: 'Chandigarh to Salasar Balaji - Hanuman Pilgrimage',
    introduction: 'Journey to the miraculous Salasar Balaji temple in Rajasthan. The 500 km route through Haryana and Rajasthan takes you to one of North India\'s most revered Hanuman temples.',
    highlights: [
    'Salasar Balaji - Wish fulfillment temple',
    'Aarti ceremonies - Daily prayers',
    'Shekhawati havelis - Painted mansions',
    'Rajasthani culture - Local traditions',
    'Free accommodation - Dharamshalas'],

    travelTips: [
    'Journey takes 9-10 hours',
    'Best time: October-March',
    'Tuesday and Saturday crowded',
    'Free accommodation available',
    'Carry water and snacks'],

    routeInfo: 'Route via Ambala, Hisar, and Churu. Long journey through Rajasthan.'
  },
  'chandigarh-shimla': {
    title: 'Chandigarh to Shimla - Summer Capital Heritage',
    introduction: 'Visit the former summer capital of British India from Chandigarh. The 115 km journey is one of the shortest hill station trips, perfect for quick weekend getaways.',
    highlights: [
    'The Ridge - Central hub with views',
    'Mall Road - Shopping and cafes',
    'Jakhu Temple - Hanuman shrine',
    'Christ Church - Colonial architecture',
    'Kufri - Nearby skiing destination',
    'Toy Train - UNESCO heritage railway'],

    travelTips: [
    'Journey takes 3-4 hours',
    'Best time: March-June, September-November',
    'Parking limited - use public transport',
    'Try local Himachali cuisine',
    'Plan rest stops for overnight stay'],

    routeInfo: 'Route via Kalka and Solan. Well-maintained roads with beautiful views.'
  },
  'chandigarh-takhat-sachkhand-sri-hazur-sahib': {
    title: 'Chandigarh to Takhat Sachkhand Sri Hazur Sahib - Sacred Sikh Pilgrimage',
    introduction: 'Embark on a long spiritual journey to one of the five Takhts of Sikhism in Nanded, Maharashtra. The 1,750 km route is a major pilgrimage where Guru Gobind Singh spent his final days.',
    highlights: [
    'Takhat Sachkhand - One of five Sikh Takhts',
    'Guru Gobind Singh history - Final resting place',
    'Langar and accommodation - Free facilities',
    'Sikh heritage - Historical significance',
    'Godavari River - Sacred bathing'],

    travelTips: [
    'Journey takes 28-30 hours; plan 2-day travel',
    'Best time: October-March',
    'Free accommodation in Gurdwara',
    'Carry sufficient food and water',
    'Plan rest stops for overnight stay'],

    routeInfo: 'Long route via Delhi, Jaipur, Kota, Indore, and Aurangabad. Major highway journey.'
  },

  // Mohali Routes
  'mohali-delhi': {
    title: 'Mohali to Delhi - Capital City Connection',
    introduction: 'Connect from Mohali to India\'s capital with comfortable group travel. The 260 km journey is perfect for business trips, family visits, or exploring Delhi\'s rich heritage.',
    highlights: [
    'India Gate - War memorial',
    'Red Fort - Mughal heritage',
    'Qutub Minar - UNESCO site',
    'Lotus Temple - Modern architecture',
    'Akshardham - Hindu temple complex',
    'Delhi markets - Shopping paradise'],

    travelTips: [
    'Journey takes 4-5 hours via NH44',
    'Best time: October-March',
    'Use Delhi Metro for local travel',
    'Try Delhi street food',
    'Book accommodations in advance'],

    routeInfo: 'Direct route via NH44 through Ambala, Karnal, and Panipat.'
  },
  'mohali-delhi-airport': {
    title: 'Mohali to Delhi Airport - Seamless Airport Transfer',
    introduction: 'Convenient group transfer from Mohali to IGI Airport Delhi. The 260 km journey ensures stress-free travel for families and groups with ample luggage space.',
    highlights: [
    'All terminals covered - T1, T2, T3',
    'Group travel comfort - Families and corporate',
    'Luggage capacity - Spacious vehicles',
    'Timely service - Punctual transfers',
    'Experienced drivers - Airport route experts'],

    travelTips: [
    'Journey takes 4-5 hours',
    'Book 6-7 hours before flight',
    'Carry all travel documents',
    'Rest stops available',
    'Monitor flight status'],

    routeInfo: 'Direct route via NH44. Well-maintained highway with facilities.'
  },
  'mohali-khatu-shyam': {
    title: 'Mohali to Khatu Shyam - Barbarika Temple Pilgrimage',
    introduction: 'Spiritual journey from Mohali to the famous Khatu Shyam temple in Rajasthan. The 490 km route takes you through Punjab, Haryana, and Rajasthan to this revered shrine.',
    highlights: [
    'Khatu Shyam Temple - Black deity',
    'Shyam Kund - Holy bathing',
    'Phalguna Mela - Annual festival',
    'Rajasthani culture - Local traditions',
    'Nearby attractions - Jaipur 100 km away'],

    travelTips: [
    'Journey takes 9-10 hours',
    'Best time: October-March',
    'Festival time is crowded',
    'Dress modestly',
    'Try Rajasthani food'],

    routeInfo: 'Route via Ambala, Hisar, and Sikar through Rajasthan countryside.'
  },
  'mohali-salasar-balaji': {
    title: 'Mohali to Salasar Balaji - Hanuman Darshan',
    introduction: 'Visit the miraculous Salasar Balaji temple from Mohali. The 510 km journey through Punjab, Haryana, and Rajasthan takes you to this powerful Hanuman shrine.',
    highlights: [
    'Salasar Balaji - Wish fulfillment temple',
    'Daily aarti - Morning and evening',
    'Shekhawati region - Painted havelis',
    'Free accommodation - Dharamshalas',
    'Rajasthani hospitality - Local culture'],

    travelTips: [
    'Journey takes 9-10 hours',
    'Best time: October-March',
    'Tuesday/Saturday crowded',
    'Free lodging available',
    'Carry essentials'],

    routeInfo: 'Route via Ambala, Hisar, and Churu. Long highway journey.'
  },
  'mohali-manali': {
    title: 'Mohali to Manali - Himalayan Adventure',
    introduction: 'Journey from Mohali to the adventure capital of Himachal. The 310 km route through mountains offers breathtaking views, adventure sports, and serene landscapes.',
    highlights: [
    'Solang Valley - Adventure sports',
    'Rohtang Pass - Snow paradise',
    'Hadimba Temple - Ancient shrine',
    'Old Manali - Bohemian culture',
    'Vashisht - Hot springs',
    'Mall Road - Shopping and dining'],

    travelTips: [
    'Journey takes 7-8 hours',
    'Best time: April-June, December-February',
    'Carry warm clothes',
    'Rohtang permit required',
    'Book hotels in advance'],

    routeInfo: 'Route via Bilaspur, Mandi, and Kullu. Scenic mountain roads.'
  },
  'mohali-himachal-pradesh': {
    title: 'Mohali to Himachal Pradesh - Complete Hill Experience',
    introduction: 'Explore multiple destinations in Himachal from Mohali. This comprehensive tour covers valleys, mountains, temples, and adventure spots across the beautiful state.',
    highlights: [
    'Multiple destinations - Shimla, Manali, Dharamshala',
    'Adventure activities - Trekking, paragliding, skiing',
    'Spiritual sites - Temples and monasteries',
    'Natural beauty - Valleys and waterfalls',
    'Local culture - Himachali traditions'],

    travelTips: [
    'Plan 7-10 days for complete tour',
    'Best time: April-June, September-November',
    'Pack layers for varying weather',
    'Book accommodations early',
    'Carry necessary permits'],

    routeInfo: 'Flexible routes covering major Himachal destinations from Mohali.'
  },
  'mohali-mussoorie': {
    title: 'Mohali to Mussoorie - Hill Station Getaway',
    introduction: 'Visit the summer capital from Mohali. The 125 km journey is perfect for weekend trips, offering colonial architecture, mountain views, and pleasant climate.',
    highlights: [
    'The Ridge - Central square',
    'Mall Road - Shopping street',
    'Jakhu Temple - Hanuman shrine',
    'Christ Church - Gothic architecture',
    'Kufri - Skiing destination',
    'Toy Train - Heritage railway'],

    travelTips: [
    'Journey takes 3-4 hours',
    'Best time: March-June, September-November',
    'Limited parking available',
    'Book hotels in advance',
    'Try local cuisine'],

    routeInfo: 'Route via Kalka and Solan. Well-maintained roads.'
  },
  'mohali-dharamshala': {
    title: 'Mohali to Dharamshala - Tibetan Culture Experience',
    introduction: 'Journey to the Dalai Lama\'s residence from Mohali. The 250 km route through Kangra Valley offers spiritual experiences, mountain views, and Tibetan culture.',
    highlights: [
    'Dalai Lama Temple - Spiritual center',
    'McLeod Ganj - Tibetan hub',
    'Bhagsu Waterfall - Scenic trek',
    'Triund Trek - Day hike',
    'Tibetan food - Momos and thukpa',
    'Norbulingka - Tibetan arts'],

    travelTips: [
    'Journey takes 5-6 hours',
    'Best time: March-June, September-November',
    'McLeod Ganj uphill from Dharamshala',
    'Respect monastery rules',
    'Try butter tea'],

    routeInfo: 'Route via Ropar and Kangra with Shivalik views.'
  },
  'mohali-dalhousie': {
    title: 'Mohali to Dalhousie - Colonial Hill Charm',
    introduction: 'Discover the British-era hill station from Mohali. The 330 km journey takes you to pine-covered hills, colonial buildings, and serene mountain landscapes.',
    highlights: [
    'Khajjiar - Mini Switzerland',
    'Kalatop Sanctuary - Wildlife',
    'St. John\'s Church - Victorian era',
    'Panchpula - Waterfalls',
    'Dainkund Peak - Highest point',
    'Chamera Lake - Boating'],

    travelTips: [
    'Journey takes 7-8 hours',
    'Best time: April-June, September-November',
    'Carry warm clothes',
    'Limited ATMs - carry cash',
    'Try Himachali dishes'],

    routeInfo: 'Route via Hoshiarpur and Pathankot. Mountain roads after Pathankot.'
  },
  'mohali-amritsar': {
    title: 'Mohali to Amritsar - Golden Temple Visit',
    introduction: 'Short pilgrimage from Mohali to Amritsar. The 220 km journey through Punjab takes you to the spiritual heart of Sikhism and the magnificent Golden Temple.',
    highlights: [
    'Golden Temple - Sacred Gurdwara',
    'Jallianwala Bagh - Historical site',
    'Wagah Border - Flag ceremony',
    'Partition Museum - History',
    'Amritsari food - Kulcha, lassi'],

    travelTips: [
    'Journey takes 4-5 hours',
    'Best time: October-March',
    'Cover head at Golden Temple',
    'Free langar available',
    'Book Wagah seats early'],

    routeInfo: 'Route via NH44 through Ludhiana and Jalandhar. Excellent roads.'
  },
  'mohali-kasol': {
    title: 'Mohali to Kasol - Backpacker Paradise',
    introduction: 'Head to the hippie village from Mohali. The 320 km journey to Parvati Valley offers cafes, trekking, and a laid-back mountain atmosphere.',
    highlights: [
    'Kasol cafes - Israeli food',
    'Parvati River - Camping',
    'Tosh Village - Mountain views',
    'Kheerganga - Hot springs trek',
    'Manikaran - Sikh shrine',
    'Malana - Ancient village'],

    travelTips: [
    'Journey takes 7-8 hours',
    'Best time: March-June, September-November',
    'Limited ATMs - carry cash',
    'Try Israeli cuisine',
    'Book accommodations early'],

    routeInfo: 'Route via Bilaspur, Mandi, and Bhuntar. Scenic after Mandi.'
  },

  // Patiala Routes
  'patiala-khatu-shyam': {
    title: 'Patiala to Khatu Shyam - Rajasthan Pilgrimage',
    introduction: 'Spiritual journey from Patiala to the famous Khatu Shyam temple. The 440 km route through Punjab, Haryana, and Rajasthan takes you to this revered Barbarika shrine.',
    highlights: [
    'Khatu Shyam Temple - Black stone deity',
    'Shyam Kund - Sacred bathing',
    'Phalguna Mela - Grand festival',
    'Rajasthani culture - Local traditions',
    'Nearby Jaipur - Pink City 100 km away'],

    travelTips: [
    'Journey takes 8-9 hours',
    'Best time: October-March',
    'Festival attracts huge crowds',
    'Dress modestly for temple',
    'Try Rajasthani thali'],

    routeInfo: 'Route via Rajpura, Ambala, Hisar, and Sikar through Rajasthan.'
  },
  'patiala-salasar-balaji': {
    title: 'Patiala to Salasar Balaji - Hanuman Temple Darshan',
    introduction: 'Visit the miraculous Salasar Balaji temple from Patiala. The 460 km journey through Punjab, Haryana, and Rajasthan takes you to this powerful Hanuman shrine.',
    highlights: [
    'Salasar Balaji Temple - Wish fulfillment',
    'Aarti ceremonies - Daily prayers',
    'Shekhawati havelis - Painted mansions',
    'Free accommodation - Dharamshalas',
    'Rajasthani hospitality - Local culture'],

    travelTips: [
    'Journey takes 8-9 hours',
    'Best time: October-March',
    'Tuesday and Saturday crowded',
    'Free lodging available',
    'Carry water and snacks'],

    routeInfo: 'Route via Rajpura, Ambala, Hisar, and Churu. Highway journey.'
  },
  'patiala-amritsar': {
    title: 'Patiala to Amritsar - Golden Temple Pilgrimage',
    introduction: 'Journey from the royal city of Patiala to the spiritual capital of Sikhism. The 208 km route through Punjab heartland takes you to the magnificent Golden Temple.',
    highlights: [
    'Golden Temple - Sacred Gurdwara',
    'Jallianwala Bagh - Memorial',
    'Wagah Border - Flag ceremony',
    'Partition Museum - History',
    'Amritsari cuisine - Kulcha, fish, lassi'],

    travelTips: [
    'Journey takes 4-5 hours',
    'Best time: October-March',
    'Cover head before entering temple',
    'Free langar 24/7',
    'Book Wagah ceremony early'],

    routeInfo: 'Route via Rajpura, Ludhiana, and Jalandhar. Excellent roads.'
  },
  'patiala-amritsar-sahib': {
    title: 'Patiala to Amritsar Sahib - Sacred Sikh Journey',
    introduction: 'Pilgrimage from Patiala to Amritsar focusing on Sikh heritage. The 208 km journey takes you to the holiest Gurdwara and other significant Sikh sites.',
    highlights: [
    'Harmandir Sahib - Golden Temple',
    'Akal Takht - Sikh temporal authority',
    'Sikh history - Museums and sites',
    'Langar seva - Community service',
    'Sikh architecture - Beautiful Gurdwaras'],

    travelTips: [
    'Journey takes 4-5 hours',
    'Best time: October-March',
    'Respect Gurdwara protocols',
    'Participate in langar seva',
    'Visit early morning for peaceful darshan'],

    routeInfo: 'Direct route via Rajpura, Ludhiana, and Jalandhar.'
  },
  'patiala-agra': {
    title: 'Patiala to Agra - Taj Mahal Wonder',
    introduction: 'Journey from Patiala to the city of the Taj Mahal. The 440 km route takes you to one of the Seven Wonders of the World and Mughal architectural marvels.',
    highlights: [
    'Taj Mahal - Wonder of the World',
    'Agra Fort - Mughal fortress',
    'Fatehpur Sikri - Ghost city',
    'Mehtab Bagh - Taj sunset view',
    'Agra cuisine - Petha, dalmoth',
    'Marble handicrafts - Shopping'],

    travelTips: [
    'Journey takes 8-9 hours',
    'Best time: October-March',
    'Visit Taj at sunrise for best experience',
    'Friday closed for Taj',
    'Try famous Agra petha'],

    routeInfo: 'Route via Rajpura, Ambala, Karnal, and Yamuna Expressway.'
  },
  'patiala-amarnath': {
    title: 'Patiala to Amarnath - Sacred Cave Pilgrimage',
    introduction: 'Undertake the challenging pilgrimage from Patiala to the holy Amarnath Cave. The 640 km journey is the first leg of this sacred yatra to Lord Shiva\'s ice lingam.',
    highlights: [
    'Amarnath Cave - Ice Shiva Lingam',
    'Pahalgam base - Starting point',
    'Trekking route - Challenging pilgrimage',
    'Baltal route - Alternative path',
    'Spiritual experience - Divine journey'],

    travelTips: [
    'Journey takes 12-14 hours to base camp',
    'Best time: July-August (yatra period)',
    'Register online for yatra',
    'Medical fitness certificate required',
    'Carry warm clothes and essentials'],

    routeInfo: 'Route via Chandigarh, Jammu, and Srinagar to Pahalgam/Baltal.'
  },
  'patiala-ayodhya': {
    title: 'Patiala to Ayodhya - Ram Janmabhoomi Pilgrimage',
    introduction: 'Journey from Patiala to the birthplace of Lord Ram. The 960 km route takes you to one of Hinduism\'s most sacred cities with newly constructed Ram Temple.',
    highlights: [
    'Ram Janmabhoomi - Birthplace temple',
    'Hanuman Garhi - Hilltop temple',
    'Saryu River - Sacred bathing',
    'Kanak Bhawan - Ram-Sita temple',
    'Ram ki Paidi - Ghats',
    'Ayodhya museums - History and culture'],

    travelTips: [
    'Journey takes 16-18 hours; plan overnight',
    'Best time: October-March',
    'Book hotels in advance',
    'Dress modestly for temples',
    'Try local prasad and sweets'],

    routeInfo: 'Long route via Delhi, Lucknow. Plan 2-day journey with rest stops.'
  },
  'patiala-char-dham': {
    title: 'Patiala to Char Dham - Ultimate Himalayan Pilgrimage',
    introduction: 'Embark on the sacred Char Dham Yatra from Patiala. This journey covers Yamunotri, Gangotri, Kedarnath, and Badrinath - the four holiest Hindu pilgrimage sites in Uttarakhand.',
    highlights: [
    'Yamunotri - Source of Yamuna',
    'Gangotri - Origin of Ganga',
    'Kedarnath - Shiva temple',
    'Badrinath - Vishnu temple',
    'Himalayan beauty - Stunning landscapes',
    'Spiritual journey - Divine experience'],

    travelTips: [
    'Plan 10-12 days for complete yatra',
    'Best time: May-June, September-October',
    'Register online for yatra',
    'Carry warm clothes and medicines',
    'Book accommodations in advance'],

    routeInfo: 'Route via Chandigarh, Dehradun, Rishikesh. Requires multiple days.'
  },
  'patiala-badrinath-kedarnath': {
    title: 'Patiala to Badrinath-Kedarnath - Do Dham Yatra',
    introduction: 'Undertake the sacred Do Dham pilgrimage from Patiala covering Kedarnath and Badrinath. This spiritual journey takes you to two of the most revered Himalayan shrines.',
    highlights: [
    'Kedarnath Temple - Shiva shrine at 11,755 ft',
    'Badrinath Temple - Vishnu shrine',
    'Himalayan peaks - Stunning views',
    'Mana Village - Last Indian village',
    'Vasuki Tal - High altitude lake',
    'Spiritual experience - Divine journey'],

    travelTips: [
    'Plan 7-9 days for yatra',
    'Best time: May-June, September-October',
    'Kedarnath requires trek or helicopter',
    'Carry warm clothes and medicines',
    'Book early in season'],

    routeInfo: 'Route via Chandigarh, Rishikesh, Gaurikund, and Joshimath.'
  },
  'patiala-dalhousie': {
    title: 'Patiala to Dalhousie - Colonial Hill Retreat',
    introduction: 'Escape to the serene hill station from Patiala. The 480 km journey takes you to pine-covered hills, colonial architecture, and peaceful mountain landscapes.',
    highlights: [
    'Khajjiar - Mini Switzerland',
    'Kalatop Wildlife Sanctuary - Dense forests',
    'St. John\'s Church - Victorian architecture',
    'Panchpula - Waterfalls and streams',
    'Dainkund Peak - Panoramic views',
    'Chamera Lake - Boating'],

    travelTips: [
    'Journey takes 9-10 hours',
    'Best time: April-June, September-November',
    'Carry warm clothes for evenings',
    'Limited ATMs - carry cash',
    'Try Himachali cuisine'],

    routeInfo: 'Route via Chandigarh, Hoshiarpur, and Pathankot. Mountain roads after Pathankot.'
  },
  'patiala-dharamshala': {
    title: 'Patiala to Dharamshala - Tibetan Culture Hub',
    introduction: 'Journey from Patiala to the home of the Dalai Lama. The 480 km route through Punjab and Himachal takes you to this spiritual center of Tibetan Buddhism.',
    highlights: [
    'Dalai Lama Temple - Spiritual center',
    'McLeod Ganj - Tibetan settlement',
    'Bhagsu Waterfall - Scenic trek',
    'Triund Trek - Popular day hike',
    'Tibetan cuisine - Momos, thukpa',
    'Norbulingka Institute - Tibetan arts'],

    travelTips: [
    'Journey takes 9-10 hours',
    'Best time: March-June, September-November',
    'McLeod Ganj is uphill from Dharamshala',
    'Respect monastery timings',
    'Try Tibetan butter tea'],

    routeInfo: 'Route via Chandigarh, Ropar, and Kangra. Beautiful mountain views.'
  },
  'patiala-golden-temple-amritsar': {
    title: 'Patiala to Golden Temple Amritsar - Sacred Sikh Pilgrimage',
    introduction: 'Dedicated pilgrimage from Patiala to the Golden Temple. The 216 km journey focuses on the spiritual experience at Harmandir Sahib and Sikh heritage sites.',
    highlights: [
    'Harmandir Sahib - Golden Temple',
    'Akal Takht - Temporal authority',
    'Langar hall - Community kitchen',
    'Sarovar - Sacred pool',
    'Sikh Museum - History and artifacts',
    'Night illumination - Beautiful lighting'],

    travelTips: [
    'Journey takes 4-5 hours',
    'Best time: October-March',
    'Cover head and remove shoes',
    'Participate in langar',
    'Visit at night for illuminated view'],

    routeInfo: 'Direct route via Rajpura, Ludhiana, and Jalandhar. Excellent roads.'
  }
};

export default tempoTravellerRoutes;